<p-toast [life]="3000" [sticky]="false"></p-toast>
<p-confirmDialog acceptLabel="{{ 'Yes' | translate }}">
</p-confirmDialog>

<div class="card-fixed-top" *ngIf="!flagAssignProvider && !hasRole('cabin_read_only')">
  <div class="card-header card-fixed-style">
    <div class="card-body-header">
      <ng-container *ngFor="let servicegroup of servicegroups">
        <!-- Íconos dinámicos -->
        <ng-container *ngFor="let action of iconActions">
          <button *ngIf="action.condition(servicegroup)" (click)="action.click(servicegroup)" class="btn-icon-service">
          <img
            class="img2"
            alt=""
            title="{{ action.title | translate }}"
            [src]="assetsBaseUrl + action.icon | company"
          />
          <div class="btn-text-icon">{{ action.title | translate }}</div>
          </button>
          
        </ng-container>

        <!-- Controles de flujo (lado derecho) -->
        <div class="col text-end" style="height: 100%; display: flex; justify-content: flex-end; align-items: center; gap: 10px;">
          <!-- Botón cancelar -->
          <button
            class="btn-icon-service cancel-bttn"
            [disabled]="!cancelprovider[servicegroup.service_id]"
            *ngIf="showCancelBtn[servicegroup.service_id] && ticketbtnshow[servicegroup.service_id] === true && iAm([
              'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
              'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'
            ])"
            (click)="ticketCancel(servicegrouptickets[servicegroup.service_id])"
          >
          
          <img alt="cancel" class="img2" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/iconsv2/cancel.svg' | company">

          <div class="btn-text-icon" style="color: white !important">Cancelar</div>

            <!-- <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/cancel_red.svg' | company"> -->
          </button>

          <!-- Botón comentar -->
          <button
            class="btn-icon-service comment-bttn"
            *ngIf="iAm([
              'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader',
              'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'quality', 'operator_cas'
            ])"
            (click)="setComment(servicegrouptickets[servicegroup.service_id])"
          >
            <img alt="comment" class="img2" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/iconsv2/comment.svg' | company">
            <div class="btn-text-icon" style="color: white !important">Comentario</div>
            <!-- <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/comment-white.svg' | company"> -->
          </button>

          <!-- Botón de chat -->
          <ng-container *ngIf="applyLinkService && isRoadmapContactChannel()">
            <button
              class="btn-icon-service chat-btn"
              (click)="openChat()"
              *ngIf="iAm(['supervisor', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_vip', 'admin', 'operator'])"
            >
            <img alt="chat" class="img2" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/iconsv2/chat-Apolo-Asisteme.svg' | company">

              <div class="btn-text-icon" style="color: #725DF1 !important">Chat</div>

            </button>
          </ng-container>

          <!-- Botón siguiente -->
          <button
            class="btn-continue"
            *ngIf="ticketbtnshow[servicegroup.service_id] === true && iAm([
              'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
              'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'quality', 'operator_cas'
            ])"
            [disabled]="stepperReadOnly || (additionalplanservice.buca_apply === 1 && blockSteps)"
            (click)="startCreategroupTicket(servicegrouptickets[servicegroup.service_id])"
            style="max-width: 215px;"
            [class.width220px]="stepperReadOnly"
          >
            <span *ngIf="!stepperReadOnly">{{ 'Next' | translate }}</span>
            <span *ngIf="stepperReadOnly">{{ 'Waiting provider' | translate }}...</span>
          </button>

          <!-- (Oculto por ahora) Botón cierre de ticket -->
          <button
            *ngIf="ticketbtnshow[servicegroup.service_id] === true && false && iAm([
              'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
              'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'
            ])"
            class="btn primary-btn-green btn-margin px-4"
            (click)="closeTicket(servicegroup.service_id, servicegrouptickets[servicegroup.service_id])"
          >
            {{ 'Billing Service' | translate }}
          </button>
        </div>
      </ng-container>
    </div>
  </div>
</div>


<div style="height: 72px;" *ngIf="!flagAssignProvider && !hasRole('cabin_read_only')"></div>

<div class="info-ticket-service" *ngIf="showDialogGeneral && !flagAssignProvider">
  <span class="btn-icon-service-header" *ngIf="service">
  <strong style="margin: 4px 8px 0px 8px;">{{ service?.name }}</strong> 
  </span>
  <i *ngIf="flagIsDangerZone" class="fa fa-exclamation-triangle" title="Zona de riesgo" style="font-size:18px; margin-left:6px; vertical-align:middle;"></i>
  <i *ngIf="flagIsHoliday" class="fa fa-calendar" title="Feriado" style="font-size:18px; margin-left:6px; vertical-align:middle;"></i>
  <ng-container *ngIf="assistancecase?.assistance_sale?.member_sale_classification == null; else notNullTemplate">
    <img alt="" *ngIf="assistancecase?.member?.member_classification" style ="width: 8em;" [src]="getUrlImageMemberClassification(assistancecase?.member?.member_classification)"> 
  </ng-container>
  <ng-template #notNullTemplate>
    <img alt="" *ngIf="assistancecase?.assistance_sale?.member_sale_classification" style ="width: 8em;" [src]="getUrlImageMemberClassification(assistancecase?.assistance_sale?.member_sale_classification)"> 
  </ng-template>
</div>



<div *ngIf="showDialogGeneral">

  <!-- CARDS INFO -->
  <div *ngIf="!flagAssignProvider">
    <div class="div-flex-around">
      <!-- INFORMACION -->
      <div class="width55">
        <div class="div-flex-around">
          <!-- Datos de Cliente -->
          <div class="card width45">
            <div class="card-header-search2 color">
              <div></div>
              <p class="p-header-table"><strong>

                  {{ 'Data of the Holder' | translate }}</strong></p>
              <button type="button" (click)="activateClientInformation()" *ngIf="!hasRole('cabin_read_only')"
                class="btn btn-circle-morfeo btn-circle-morfeo-xs">
                <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/more1.svg' | company" alt="">
              </button>

            </div>
            <div class="card-body-search card-column-flex">
              <table style="margin-bottom: 1rem;" aria-label="membertable">
                <th scope="col"></th>
                <tr style="background:#ffffff">
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ assistancecase?.member?.name | titlecase }}</strong>
                      <a class="member-info" style="color: black; text-decoration: none; margin-left:5px;"
                        (click)="billInfo2.show($event)">
                        <i style="color: #0277BD;     margin-left: 5px;" class="fa fa-info-circle pointer"></i>
                      </a>
                    </p>

                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;">
                    <div class="row" style="display: flex;">
                    
                      
                   
                      <div class="col-md-4">
                        <p><strong>{{ 'Phone' | translate }}</strong></p>
                      </div>
                        <div class="col-md-8">
                          <div [hidden]="editphoneFlag"style="color: #70BE21;margin-left: 8px; cursor: pointer; display: contents"><strong>{{ phone }}</strong></div>
                          <div [hidden]="editphoneFlag == false" style="color: #70BE21;margin-left: 8px; cursor: pointer; display: contents">
                            <input type="text" class=" col-md-8" onFocus="this.select()"
                                         name="phone" [(ngModel)]="phone" style="display: table-cell;"></div>
                                          
                              <a style="color: #0277BD;     margin-left: 5px;" (click)="editCasephone()"
                                 *ngIf="iAm([
                                              'assistance_admin', 'supervisor', 'operator',
                                              'networkleader'
                                            ])">
                              <img *ngIf="assistancecase && assistancecase?.status == 1" alt="" style="color: #0277BD;     margin-left: 5px;" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/edit.svg' | company"> </a>
                                       
                              <a style="color: #0277BD;     margin-left: 5px;" (click)="updateCaseinfo()"
                                            *ngIf="(editphoneFlag==true) ||editemailFlag==true
                                            && iAm([
                                              'assistance_admin', 'supervisor', 'operator', 'networkleader'
                                            ])">
                              <img alt="" style="color: #0277BD;  width: 23px; height: 23px;   margin-left: 5px;" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/approve.svg' | company"> </a>
                              
                              <div>
                                <div [hidden]="phone2 && editphone2Flag" style="color: #70BE21;margin-left: 8px; cursor: pointer;display: contents"><strong>{{ phone2 }}</strong></div>
                                <div [hidden]="editphone2Flag == false" style="color: #70BE21;margin-left: 8px; cursor: pointer;display: contents"><input type="text" class=" col-md-8" onFocus="this.select()"
                                                    name="phone2" [(ngModel)]="phone2"></div>
                                                    <a style="color: #0277BD;     margin-left: 5px;" (click)="editCasephone2()"
                                                *ngIf="iAm([
                                                  'assistance_admin', 'supervisor', 'operator',
                                                  'networkleader'
                                                ])">
                                                <img *ngIf="assistancecase && assistancecase?.status == 1" alt="" style="color: #0277BD;     margin-left: 5px;" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/edit.svg' | company"> </a>
                                           
                                                <a style="color: #0277BD;     margin-left: 5px;" (click)="updateCaseinfo()"
                                                *ngIf="(editphone2Flag==true)
                                                && iAm([
                                                  'assistance_admin', 'supervisor', 'operator', 'networkleader'
                                                ])">
                                                <img alt="" style="color: #0277BD;  width: 23px; height: 23px;   margin-left: 5px;" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/approve.svg' | company"> </a>
                          
                              </div>
                          
                        
                    </div>                      
                      
                        
                                          
                          
                                          
                                     
                                        
                                          
                    </div>
                    

                    

                  </td>
             
                </tr>
                
                <tr>
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'ID' | translate }}: {{assistancecase?.member?.national_id}}</strong></p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'Address' | translate }}: {{complete_address}}</strong></p>
                  </td>
                </tr>
                <tr *ngIf="additionalplanservice && additionalplanservice.special_condition">
                  <td style="padding-left: 1rem;">
                    <p><strong>Plan {{ 'Special condition/Observations' | translate }}:</strong>
                      {{ additionalplanservice.special_condition }}
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!-- Datos de Gestion -->
          <div class="card width45">
            <div class="card-header-search2 color">
              <div></div>
              <div style="display: flex;">
                <app-flags class="flag-position" *ngIf="assistancecase?.country" [country]="assistancecase?.country">
                </app-flags>
                <p class="p-header-table"><strong>{{ 'Management data' | translate }} #{{assistancecase?.id}}</strong></p>
                <a (click)="showCaseCardInfo()" type="button" class="btn btn-circle-morfeo btn-circle-morfeo-xs" *ngIf="!hasRole('cabin_read_only')">
                  <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/more1.svg' | company" alt="">
                </a>
              </div>
              <div></div>
            </div>
            <div class="card-body-search card-column-flex">
              <div class="table-responsive w-100">
                <table style="margin-bottom: 1rem;" aria-label="contactchanneltable">
                  <th scope="col"></th>
                  <tr style="background: #ffffff;">
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'Contact Channel' | translate }}:</strong> {{ channels[assistancecase?.contact_channel] || "---" }}
                      </p>
                    </td>
                  </tr>
                  <tr style="background: #ffffff;">
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'Operator' | translate }}:</strong> {{ assistancecase?.created_by_user?.username || "---" }}
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'Dispatcher' | translate }}:</strong> {{ assistancecase?.created_by?.username || "---" }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'State District' | translate }}:</strong> {{ assistancecase?.stateDistrict?.name | titlecase
                        }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'Claim Number' | translate }}:</strong> {{ (assistancecase?.sds_sinister_claim?.claim_number | titlecase) || ('Not Assigned' | translate) }}</p>
                    </td>
                  </tr>
                  <tr *ngIf="assistancecase?.assistance_sale">
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'Policy' | translate }}:</strong> {{ (assistancecase?.assistance_sale?.code | titlecase) || ('Not Found' | translate) }}</p>
                    </td>
                  </tr>
                  <tr *ngIf="buca_plan_service">
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'Max Amount' | translate }}:</strong> {{buca_currency}} {{buca_max_amount}}</p>
                    </td>
                  </tr>
                  <tr *ngIf="buca_plan_service">
                    <td style="padding-left: 1rem;">
                      <p><strong>{{ 'Amount Available' | translate }}:</strong> {{buca_currency}} {{buca_amount_available}}</p>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="div-flex-around">
          <!-- Datos de asistencia -->
          <div class="card width95">
            <div class="card-header-search2 color">
              <div></div>
              <div>
                <p class="p-header-table"> {{ 'Attendance data' | translate }}</p>
              </div>
              <div></div>
            </div>
            <div class="card-body-search card-column-flex">
              <table style="margin-bottom: 1rem;" aria-label="infoproducttable">
                <th scope="col"></th>
                <tr style="background: #ffffff;">
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'Product' | translate }}: </strong>{{ assistancecase?.product?.name}}</p>
                  </td>
                  <td>
                    <p><strong>{{ 'Type of Services' | translate }}:</strong>
                      <span *ngFor="let serviceCategory of serviceCategories">
                        {{ serviceCategory }}
                      </span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'Dependent not reported' | translate }}: </strong>
                      {{ assistancecase?.applicant_name || "---" }}
                    </p>
                  </td>
                  <td>
                    <p><strong>{{ 'Plan' | translate }}:</strong>
                      {{ assistancecase?.plan?.name}} : {{ assistancecase?.plan?.id}}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'Number of assists consumed' | translate }}:</strong>
                      {{ used_services || "---" }}
                    </p>
                  </td>
                  <td>
                    <p><strong>{{ 'Number of assists available' | translate }}:</strong>
                      {{ remaining_assistances || "---" }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'Max Amount per Event' | translate }}:</strong>
                      {{ plan_max_amount_events || "---" }}
                    </p>
                  </td>
                  <td>
                    <p><strong>{{ 'Activation Time' | translate }}:</strong>
                      {{ assistancecase?.assistance_sale?.date_effective | date:'dd/MM/yyyy' }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;" *ngIf="assistancecase?.appointment_date ">
                    <p><strong>{{ 'Appointment Date' | translate }}:</strong>
                      {{ assistancecase?.appointment_date 
                        | currentDate: {hourTimeZone}
                        | date:'d MMM, hh:mm a'}}
                    </p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="div-flex-around">
          <!-- Datos de Proveedor -->
          <div [ngClass]="showVial? 'card width45' : 'card width95'">
            <div class="card-header-search2 color">
              <div></div>
              <p class="p-header-table"><strong>{{ 'Provider Data' | translate }}</strong></p>
              <button (click)="showProviderCard()" type="button" class="btn btn-circle-morfeo btn-circle-morfeo-xs" *ngIf="!hasRole('cabin_read_only')">
                <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/more1.svg' | company" alt="">
              </button>
            </div>
            <div class="card-body-search card-column-flex">
              <table style="margin-bottom: 1rem;" aria-label="providernametable">
                <th scope="col"></th>
                <tr *ngIf="provider" style="background: #ffffff;">
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ provider?.name | titlecase }}</strong></p>
                  </td>
                </tr>
                <tr *ngIf="provider">
                  <td style="padding-left: 1rem;">
                    <div class="th-body-table">
                      <p><strong>{{ 'Phone' | translate }}</strong></p>
                      <div style="display: flex; flex-direction: column;">
                        <div
                          *ngFor="let phone_provider of ((provider.phones_cabin || '') || (provider.contact_phones || '')).split(',')"
                          style="color: #70BE21;margin-left: 8px; cursor: pointer;"><strong>{{ phone_provider }}</strong></div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr *ngIf="provider">
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'State District' | translate }}:</strong> {{ assistancecase?.stateDistrict?.name | titlecase }}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'Service' | translate }}:</strong> {{ (service?.name) | titlecase }}</p>
                  </td>
                </tr>
                <tr *ngIf="arrivalcode != undefined">
                  <td style="padding-left: 1rem;">
                    <p><strong>{{ 'Provider Arrival Code' | translate }}:</strong> {{ arrivalcode }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!-- Datos de vehiculo -->
          <div class="card width45" *ngIf="showVial">
            <div class="card-header-search2 color">
              <div></div>
              <div style="display: flex;">
                <p><strong>{{ 'Vehicle data' | translate }}:</strong></p>
              </div>
              <div></div>
            </div>
            <div class="card-body-search card-column-flex" *ngFor="let servicegroup of servicegroups">
              <table style="margin-bottom: 1rem;" aria-label="carbrandtable">
                <th scope="col"></th>
                <tr style="background: #ffffff;">
                  <td style="padding-left: 1rem;">
                    <p *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2 && assistancecase?.assistance_sale; else elsecarbrand">
                      <strong> {{ 'Car Brand' | translate }}: </strong> {{  assistanceSaleCar?.brand_description }}
                    </p>
                    <ng-template #elsecarbrand>
                      <p><strong>{{ 'Car Brand' | translate }}: </strong>{{ servicegroup?.brand_description || servicegroup?.car_brand_desc || servicegroup?.car_model?.brand?.name}}</p>
                    </ng-template>
                  </td>
                  <td>
                    <p *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2 && assistancecase?.assistance_sale; else elsecarmodel">
                      <strong> {{ 'Car Model' | translate }}: </strong> {{  assistanceSaleCar?.model_description }}
                    </p>
                    <ng-template #elsecarmodel>
                      <p><strong>{{ 'Car Model' | translate }}: </strong>{{ servicegroup?.model_description || servicegroup?.car_model_desc || servicegroup?.car_model?.name}}</p>
                    </ng-template>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;">
                    <p *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2 && assistancecase?.assistance_sale; else elsecaryear">
                      <strong> {{ 'Car Year' | translate }}: </strong> {{  assistanceSaleCar?.car_year }}
                    </p>
                    <ng-template #elsecaryear>
                      <p><strong>{{ 'Car Year' | translate }}: </strong>{{ servicegroup.car_year }}</p>
                    </ng-template>
                  </td>
                  <td>
                    <p *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2 && assistancecase?.assistance_sale; else elsecarplate">
                      <strong> {{ 'Car Plate' | translate }}: </strong> {{  assistanceSaleCar?.car_plate }}
                    </p>
                    <ng-template #elsecarplate>
                      <p><strong>{{ 'Car Plate' | translate }}: </strong>{{ servicegroup.car_plate }}</p>
                    </ng-template>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;" colspan="2">
                    <p><strong>{{ 'Car Color' | translate }}: </strong>
                      <span>{{ assistanceSaleCar?.color_description || servicegroup?.color_description || servicegroup?.car_color_desc }}</span>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;" colspan="2">
                    <p><strong>#{{ 'Serie' | translate }}: </strong> {{ servicegroup.car_serial_number }}</p>
                  </td>
                </tr>
                <tr>
                  <td style="padding-left: 1rem;" colspan="2">
                    <p><strong>#{{ 'Vehicle reference' | translate }}: </strong> {{ servicegroup.vehicle_reference }}</p>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- MAPA -->
      <div class="width40">
        <div class="div-flex-around">
          <div class="card width95">
            <div class="card-header-search2 color">
              <div></div>
              <div style="display: flex;">
                <p>{{ 'Supplier customer location' | translate }}</p>
                <a (click)="showCaseCard()" type="button" class="btn btn-circle-morfeo btn-circle-morfeo-xs" *ngIf="!hasRole('cabin_read_only')">
                  <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/more1.svg' | company" alt="">
                </a>


                <a (click)="viewCallDialog()" type="button" class="btn btn-circle-morfeo btn-circle-morfeo-xs" *ngIf="!hasRole('cabin_read_only')">
                  <img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_customer.svg' | company" alt="" title="Solicitar ubicación cliente">
                </a>


              </div>
              <div></div>
            </div>
            <div class="card-body-search card-column-flex">
              <iframe
                *ngIf="isEmbeddedMap"
                width="100%"
                height="865vh"
                style="border:0"
                loading="lazy"
                title="Google Map"
                allowfullscreen
                referrerpolicy="no-referrer-when-downgrade"
                [src]="embeddedMapUrl">
              </iframe>
              <img *ngIf="!isEmbeddedMap" style="width: 100%; height: 77vh;" [src]="urlStaticMap" alt="Google Map">


              <div style="display: none;">
                <app-select-location #selectLocationComp [location]="caseLocation" [memberLocation]="memberLocation"
                [stateLocation]="stateLocation" [showMap]="showMap" [captureLocation]="true"
                [member_id]="assistancecase.member_id" [email]="assistancecase.email" [phone]="assistancecase.phone"
                [otherPhone]="otherPhone"
                [selectedPhone]="selectedPhone"
                [requireDataLatLng]="true" [country_phone_code]="assistancecase.country_phone_code"
                (selectLocation)="onSelectLocation($event)" [country_code]="country_id">
              </app-select-location>
              </div>
          




            </div>
            <div style="display: flex;" *ngIf="isCaseApp && (isClientLocation || isProviderLiveLocation)">
              <p>{{ 'See location in realtime' | translate }}</p>
              <a (click)="openLinkAssistanceCaseApp()">
                <img class="img-space-pointer" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/eye.svg' | company" alt="">
              </a>
            </div>
            <div style="display: flex;" *ngIf="!isCaseApp || (!isClientLocation && !isProviderLiveLocation)">
              <p style="color: gray;">{{ 'Real time location not available' | translate }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- END CARDS INFO -->

  <div class="times-margin" *ngIf="!flagAssignProvider">
    <div class="cases-from">
      <div class="card" *ngFor="let servicegroup of servicegroups">
        <div class="card-header-search">
          <table class="times-table" aria-label="perspectivetable">
            <th scope="col"></th>
            <tr>
              <td>
                <app-elapsedticket-time [img_url]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/customer.svg'"
                  [starttime]="assistancecase?.date_start" [endtime]="clientEndTime[servicegroup.service_id]"
                  [title]="'Client Perspective'">
                </app-elapsedticket-time>
              </td>
              <td>
                <app-elapsedticket-time [img_url]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/truck.svg'"
                  [starttime]="providerStartTime[servicegroup.service_id]"
                  [endtime]="providerEndTime[servicegroup.service_id]" [title]="'Provider Assignment'">
                </app-elapsedticket-time>
              </td>
              <td>
                <app-elapsedticket-time [img_url]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/location_customer.svg'"
                  [starttime]="ArrivalStartTime[servicegroup.service_id]"
                  [endtime]="ArrivalEndTime[servicegroup.service_id]" [title]="'Provider Arrival'">
                </app-elapsedticket-time>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>

  <div class="display-steps" *ngFor="let servicegroup of servicegroups">
    <app-assistance-tickets-step class="steps-center" [totalCount]="totalCount" [servicegroup]="servicegroup" [by_connection]="findByConnectionTicket()"
      [grouptickets]="servicegrouptickets[servicegroup.service_id]" [categories]="assistancecategories"
      [countries]="countries" [flagAssignProvider]="flagAssignProvider" [showstep]="showstep[servicegroup.service_id]"
      [assistancecase]="assistancecase" [caseLocation]="caseLocation" [disabled]="isDisabled"
      [disableallstep]="disableallstep" [sale_canceled]="sale_canceled" [titular_name]="assistancecase?.member?.name"
      [tel]="phone" [readonly]="stepperReadOnly" [tipo_servicio]="serviceCategories[0]"
      [usuario_asesor]="assistancecase?.created_by?.username" (notifyAssignProviderView)="notifyAssignProviderView()"
      [id_service]="service_id" [sds_provider]="sds_provider" [copago]="copago" [pago_copago]="pago_copago" [buca_plan_service]="buca_plan_service" [sinister_plan_service] = "sinister_plan_service" [assistance_plan_service]="additionalplanservice"
      (update)="onTicketCreate($event)" (setUserProvider)="gotUserProvider($event)" (activeIndexReady)="onStepsActiveIndexReady(
          $event, servicegroup.service_id
        )" (quotationComment)="onQuotationComment($event)"
        [inlatitude]="assistancecase.latitude" [inlongitude]="assistancecase.longitude" 
        >
    </app-assistance-tickets-step>
  </div>

  <div *ngIf="!flagAssignProvider">
    <div class="cases-from mb-4">
      <div class="card" *ngFor="let servicegroup of servicegroups">
        <div class="card-header-search">
          <table class="table-morfeo w-100" aria-label="servicegrouptable">
            <thead>
              <tr>
                <th scope="col">
                </th>
                <th scope="col" (click)="sort_date_desc = !sort_date_desc;" class="td-wd text-center">
                  {{ 'Date' | translate }}
                  <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/sort.svg' | company">
                </th>
                <th scope="col" class="td-wd text-center">
                  {{ 'User' | translate }}
                </th>
                <th scope="col" class="td-wd text-center">
                  {{ 'Name' | translate }}
                </th>
                <th scope="col" class="td-wd text-center">
                  {{ 'Phone' | translate }}
                </th>
                <th scope="col" class="td-wd text-center">
                  {{ 'Type' | translate }}
                </th>
                <th scope="col" class="td-wd text-center">
                  {{ 'Provider' | translate }}
                </th>
                <th scope="col"   class="comment">
                  {{ 'Triage' | translate }}
                </th>
                <th scope="col" class="comment td-wd text-center">
                  {{ 'Comment' | translate }}
                </th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody *ngIf="sort_date_desc">
              <tr *ngFor="let assistanceticket of
                  servicegrouptickets[servicegroup.service_id] ">
                <td>
                  <i *ngIf="assistanceticket.communication==1;" class="fa fa-phone" type="text" pTooltip="Phone"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==2;" class="fa fa-android" type="text" pTooltip="App"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==3;" class="fa fa-commenting-o" type="text" pTooltip="Chat"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==4;" class="fa fa-whatsapp" type="text" pTooltip="WhatsApp"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==5;" class="fa fa-envelope-o" type="text" pTooltip="Email"
                    tooltipPosition="left">
                  </i>
                </td>
                <td class="no-wrap">
                  <span>
                    {{
                    assistanceticket.datetime
                    | currentDate: {hourTimeZone}
                    | date:'d MMM yyyy, hh:mm a'
                    }}
                  </span>
                </td>
                <td>
                  {{ assistanceticket.user? assistanceticket.user.username: '' }}
                </td>
                <td>
                  {{ assistanceticket.user? assistanceticket.user.name: '' }}
                </td>
                <td>
                  {{ assistanceticket.user? assistanceticket.user.phone_number: '' }}
                </td>
                <td>
                  <span *ngIf="assistanceticket.ticket_type==1;">
                    {{'Assign Service' | translate }} 
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==2;">
                    {{'Assign Provider' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==3;">
                    {{'Notify to customer' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==4;">
                    {{'Provider Arrived' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==50;">
                    {{'Arrival registered from the app' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==5;">
                    {{'Closed' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==6;">
                    {{'Canceled by Supervisor' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==7;">
                    {{'Canceled by Client' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT;">
                    {{'Service by reimbursement' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==8;">
                    {{'Canceled by Provider' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==9;">
                    {{'Comment' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==10;">
                    {{ 'Canceled by Client, Without Cost' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==11;">
                    {{'Programmed' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==12;">
                    {{'By Connection' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==14;">
                    {{'Exception' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==15;">
                    {{'Reimburse' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==22;">
                    {{'Courtesy' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==16;">
                    {{'Notify to customer' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==17;">
                    {{'Assign / Unassign' | translate }} 
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==30;">
                    {{'Recordination' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==35;">
                      {{'Cabin Exception' | translate }} 
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==36;">
                      {{'Cabin Exception Authorization' | translate }}
                    </span>
                </td>
                <td>
                  <span *ngIf="assistanceticket.provider_id">
                    {{assistanceticket.provider.name}}
                  </span>
                </td>

                <td class="comment">
                  <span *ngIf= "assistanceticket.triage == 1" >{{'Red' | translate}}</span>
                  <span *ngIf= "assistanceticket.triage == 2" >{{'Yellow' | translate}}</span>
                  <span *ngIf= "assistanceticket.triage == 3" >{{'Green' | translate}}</span>
                  <span *ngIf= "assistanceticket.triage == null" >{{' ' | translate}}</span>
                </td>
                <td class="comment" style="max-width: 40vw;">

                  <div>                    
                    <span>{{ assistanceticket.comment }}</span>
                    &nbsp;
                    <span>{{ assistanceticket.ticket_type == 1 && answers_text ? answers_text : '' }}</span>
                    <span 
                      *ngIf="assistanceticket.ticket_type == 6 || assistanceticket.ticket_type == 7 || assistanceticket.ticket_type == 8 || assistanceticket.ticket_type == 10">
                      {{ '- Motivo: ' + assistanceticket?.cancellation_reason_typology + ', Submotivo: ' + assistanceticket?.cancellation_reason_subtypology }}
                    </span>
                  </div>
                </td>
                <td>
                  <a *ngIf="editbtnshow[servicegroup.service_id]==true
                      && assistanceticket.ticket_type != 16
                      && assistanceticket.ticket_type != 17
                      && assistanceticket.ticket_type != 1
                      && assistanceticket ===
                        servicegrouptickets[servicegroup.service_id][0]" (click)="editComment(assistanceticket)">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                  <a *ngIf="assistanceticket.ticket_type==4;" (click)="editDate()">
                    <i class="fa fa-calendar-check-o" aria-hidden="true" *ngIf="iAm(['assistance_admin']);"></i>
                  </a>

                </td>
              </tr>
            </tbody>

            <tbody *ngIf="!sort_date_desc">
              <tr *ngFor="let assistanceticket of
                  servicegrouptickets[servicegroup.service_id].slice().reverse() ">
                <td>
                  <i *ngIf="assistanceticket.communication==1;" class="fa fa-phone" type="text" pTooltip="Phone"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==2;" class="fa fa-android" type="text" pTooltip="App"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==3;" class="fa fa-commenting-o" type="text" pTooltip="Chat"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==4;" class="fa fa-whatsapp" type="text" pTooltip="WhatsApp"
                    tooltipPosition="left">
                  </i>
                  <i *ngIf="assistanceticket.communication==5;" class="fa fa-envelope-o" type="text" pTooltip="Email"
                    tooltipPosition="left">
                  </i>
                </td>
                <td class="no-wrap">
                  <span>
                    {{
                    assistanceticket.datetime
                    | currentDate: {offset:hourTimeZone}
                    | date:'d MMM, hh:mm a'
                    }}
                  </span>
                </td>
                <td>
                  {{ assistanceticket.user? assistanceticket.user.username: '' }}
                </td>
                <td>
                  <span *ngIf="assistanceticket.ticket_type==1;">
                    {{'Assign Service' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==2;">
                    {{'Assign Provider' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==3;">
                    {{'Notify to customer' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==4;">
                    {{'Provider Arrived' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==50;">
                    {{'Arrival registered from the app' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==5;">
                    {{'Closed' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==6;">
                    {{'Canceled by Supervisor' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==7;">
                    {{'Canceled by Client' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT;">
                    {{'Service by reimbursement' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==8;">
                    {{'Canceled by Provider' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==9;">
                    {{'Comment' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==10;">
                    {{ 'Canceled by Client, Without Cost' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==11;">
                    {{'Programmed' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==12;">
                    {{'By Connection' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==14;"> 
                    {{'Exception' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==15;">
                    {{'Reimburse' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==16;">
                    {{'Notify to customer' | translate }}
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==17;">
                    {{'Assign / Unassign' | translate }} 
                  </span>
                  <span *ngIf="assistanceticket.ticket_type==35;">
                      {{'Cabin Exception' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==36;">
                      {{'Cabin Exception Authorization' | translate }}
                    </span>
                </td>
                <td>
                  <span *ngIf="assistanceticket.provider_id">
                    {{assistanceticket.provider.name}}
                  </span>
                </td>

                <td class="comment">
                  <span *ngIf= "assistanceticket.triage == 1" >{{'Red' | translate}}</span>
                  <span *ngIf= "assistanceticket.triage == 2" >{{'Yellow' | translate}}</span>
                  <span *ngIf= "assistanceticket.triage == 3" >{{'Green' | translate}}</span>
                  <span *ngIf= "assistanceticket.triage == null" >{{' ' | translate}}</span>
                </td>

                <td class="comment">
                  <div>
                    <span>{{assistanceticket.comment}}</span>
                  </div>
                </td>
                <td>
                  <a *ngIf="editbtnshow[servicegroup.service_id]==true
                      && assistanceticket.ticket_type != 16
                      && assistanceticket.ticket_type != 17
                      && assistanceticket.ticket_type != 1
                      && assistanceticket ===
                        servicegrouptickets[servicegroup.service_id][0]" (click)="editComment(assistanceticket)">
                    <i class="fa fa-pencil" aria-hidden="true"></i>
                  </a>
                  <a *ngIf="assistanceticket.ticket_type==4;" (click)="editDate()">
                    <i class="fa fa-calendar-check-o" aria-hidden="true" *ngIf="iAm(['assistance_admin']);"></i>
                  </a>
                  <a *ngIf="assistanceticket.ticket_type==14;" (click)="openExceptionDialog(assistanceticket)">
                    <i class="fa fa-search" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="card-header-search brd" *ngIf="!hasRole('cabin_read_only')">
          <div class="card-buttons-footer">
            <div class="card-left-footer">

            </div>
            <div class="card-right-footer">

              <button *ngIf="iAm([
                  'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
                  'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'quality'
                ])" class="btn secundary-btn-green wa btn-margin" (click)="showPhonesNumberDialog = true">
                <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-green.svg' | company">
              </button>
              <button class="btn primary-btn-green btn-margin px-4" *ngIf="ticketbtnshow[servicegroup.service_id]==true && iAm([
                  'assistance_admin', 'supervisor', 'operator', 'operator_cas', 'cabin_agent',
                  'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'quality'
                ])"
                [disabled]="stepperReadOnly || (additionalplanservice.buca_apply == 1 && blockSteps)" (click)="startCreategroupTicket(servicegrouptickets[
                    servicegroup.service_id
                  ])" style="max-width: 215px;">
                <span *ngIf="!stepperReadOnly">
                  {{ 'Next step' | translate }}
                </span>
                <span *ngIf="stepperReadOnly">
                  {{ "Waiting provider" | translate }}...
                </span>
              </button>



            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<!--VISTA DE ESCUCHAR AUDIOS-->
<form class="cases-form" #form="ngForm" *ngIf="showAudiosDialog">
  <div class="card mt-3 mb-3">
    <div class="card-header-search color">
      <img alt="" class="go-to-back-title go-to-back-title2"
        (click)="showAudiosDialog = false; showProgramedService = false; showDialogGeneral = true; showBillFormDialog = false; showExceptionDialog = false;"
        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">
      <p>{{ 'Case Audios' | translate }}</p>
    </div>
    <div class="row">
      <div class="spaceup">

      </div>
      <div class="col-md-1"></div>
      <div class="col-md-7">
        
        <table *ngIf="caseAudios?.length != 0" class="table-hover" aria-label="caseaudiostable">
          <thead style="background:#f9f9f9">
            <tr>
              <th scope="col" width="15%">{{ 'User' | translate }}</th>
              <th scope="col" width="15%">{{ 'Date' | translate }}</th>
              <th scope="col" width="15%">{{ 'Hour' | translate }}</th>
              <th scope="col" width="20%">{{ 'ID' | translate }}</th>
              <th scope="col" width="35%"></th>

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let audio of caseAudios">
              <td>
                {{ audio?.callerLastName }}
              </td>
              <td>
                {{ audio?.startTime | date : 'dd-MM-yyyy' }}
              </td>
              <td>
                <!-- {{ audio?.updated_time }} -->
                {{ audio?.startTime | date : 'HH:mm' }}
              </td>
              <td>
                <span title="Copiar" class="hoverClip" (click)="copyToClipBoard(audio.pkId)">{{audio?.pkId}}</span>
              </td>
              <td>
                <button *ngIf="audio?.showButton" class="btn btn-success btn-style" (click)="getAudio(audio?.pkId)">
                  {{ 'Search Audio'  | translate }}
                </button>
                <audio controls *ngIf="audio?.showAudio">
                  <source src={{audio?.audioURL}} type="audio/wav">
                </audio>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</form>
<!-- VISTA DE ASISTENCIA PROGRAMADA -->
<form class="cases-from" #form="ngForm" *ngIf="showProgramedService">
  <div class="card mt-3 mb-3">
    <div class="card-header-search color">
      <img alt="" class="go-to-back-title go-to-back-title2"
        (click)="showProgramedService = false; showDialogGeneral = true; showBillFormDialog = false; showExceptionDialog = false;"
        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">
      <p>{{ 'Schedule Assistance' | translate }}</p>
    </div>
    <div class="card-header-search padding">
      <div>
        <h2 class="h2-center"><strong>{{ 'Select the scheduling reason' | translate }}</strong></h2>
        <div class="cases-from">
          <div class="card" style="width: 100%;">
            <div class="form-check">
              <table class="table-exceptions" aria-label="assistanceprogrammingtable">
                <th scope="col"></th>
                <tr *ngFor="let item of assistance_programming_types">
                  <td>
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="{{item.id}}"
                      value="{{item.id}}" (change)="onChangeItemSelected(item)" ngModel required>
                    <label class="form-check-label" for="{{item.id}}">
                      {{ item.name }}
                    </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>


      <div>
        <h2 class="h2-center">
          <strong>{{ "Select the scheduling sub reason" | translate }}</strong>
        </h2>
        <div class="cases-from">
          <div class="card" style="width: 100%">
            <div class="form-check">
              <table class="table-exceptions" *ngIf="!assistance_programming_subtypes.length" aria-label="subtypestable">
                <th scope="col"></th>
                <tr >
                  <td>
                    <input class="form-check-input" type="radio" name="program_subtype" 
                      value="{{ null }}" (change)="onSelectProgramSubType_($event,null)" ngModel />
                    <label class="form-check-label" >
                      {{ "No Aplica" }}
                    </label>
                  </td>
                </tr>
              </table>
              <table class="table-exceptions" *ngIf="assistance_programming_subtypes.length" aria-label="programmingtypestable">
                <th scope="col"></th>
                <tr *ngFor="let item of assistance_programming_subtypes">
                  <td>
                    <input class="form-check-input" type="radio" name="program_subtype" 
                      value="{{ item.code }}" (change)="onSelectProgramSubType_($event, item.code)" ngModel required />
                    <label class="form-check-label" for="{{ item.id }}">
                      {{ item.description_es }}
                    </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      
      <div class="div-vl"></div>
      <div>
        <h2 class="h2-center"><strong>{{ 'Select date and time for attendance' | translate }}</strong></h2>
        <p-datepicker [inline]="true" [required]="true" name="dateControl" [showTime]="true" hourFormat="24"
          [(ngModel)]="programTimeService"></p-datepicker>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 px-5">
        <h2><strong>{{ 'Comment' | translate }}:</strong></h2>
        <div>
          <textarea rows="5" class="form-control" name="comment" [(ngModel)]="commentServiceConfig" required>
          </textarea>
        </div>
      </div>
    </div>
    <br>
    <!-- footer -->
    <div class="card-header-search brd">
      <div class="card-buttons-footer">
        <div class="card-left-footer">

        </div>
        <div class="card-right-footer">
          <button class="btn secundary-btn btn secundary-btn-fw"
            (click)="showProgramedService = false; showDialogGeneral = true; showBillFormDialog = false; showExceptionDialog = false;">
            {{ 'Cancel' | translate }} </button>
          <button class="btn primary-btn primary-btn-fw" [disabled]="form.form.invalid"
            (click)="onSetServiceProgramed()"> {{ 'Program' | translate }} </button>
        </div>
      </div>
    </div>
  </div>
</form>

<!-- VISTA DE EXCEPCIONES -->
<form class="cases-from" #form="ngForm" *ngIf="showExceptionDialog">
  <div class="card mt-3 mb-3">
    <div class="card-header-search color">
      <img alt="" class="go-to-back-title go-to-back-title2"
        (click)="showExceptionDialog = false; showBillFormDialog = false; showDialogGeneral = true; showProgramedService = false;"
        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">
      <p>{{ 'Exception' | translate }}</p>
    </div>
    <div class="card-header-search padding">
      <div class="div-md-60">
        <div class="cases-from">
          <div class="card" style="width: 100%;">
            <div class="form-check">
              <table class="table-exceptions" aria-label="exceptionstable">
                <th scope="col"></th>
                <tr *ngFor="let item of exceptionsType">
                  <td>
                    <input class="form-check-input" type="radio" name="flexRadioDefault" id="{{item.id}}"
                      value="{{item.id}}" (change)="onChangeItemSelected(item)" ngModel required>
                    <label class="form-check-label" for="{{item.id}}">
                      {{ item.name }}
                    </label>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="div-vl"></div>
      <div class="div-md-30">
        <div class="form-group">
          <h2><strong>{{ 'Supervisor Confirm' | translate }}:</strong></h2>
          <div class="col-sm-9">
            <select class="form-control" name="type" [(ngModel)]="supervisorSelectedException" required>
              <option *ngFor="let supervisor of supervisors" [ngValue]="supervisor.id">{{ supervisor.name }}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <h2><strong>{{ 'Comment' | translate }}:</strong></h2>
          <div>
            <textarea rows="5" class="form-control" name="comment" [(ngModel)]="commentServiceConfig" required>
            </textarea>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="card-header-search brd">
      <div class="card-buttons-footer">
        <div class="card-left-footer">

        </div>
        <div class="card-right-footer">
          <button class="btn secundary-btn btn secundary-btn-fw"
            (click)="showDialogGeneral = true; showExceptionDialog = false"> {{ 'Cancel' | translate }} </button>
          <button class="btn primary-btn primary-btn-fw" [disabled]="form.form.invalid" (click)="onSetException()"> {{
            'Apply' | translate }} </button>
        </div>
      </div>
    </div>
  </div>
</form>


<!-- BILL FORM Whit Carta porte-->
<div class="cases-from" [hidden]="!showBillFormDialog">
  <div class="card mt-3 mb-3">
    <div class="card-header-search color">
      <img alt="" class="go-to-back-title go-to-back-title2" (click)="goBackBillForm()"
        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">
      <p> {{ 'Create New Bill' | translate }}
        <a class="member-info" style="color: black; text-decoration: none">
          <i *ngIf="billprice" class="fa fa-info-circle pointer" (click)="billInfo.show($event)">
          </i>
        </a>
      </p>
    </div>
    <div class="card-header-search padding">
      <div class="div-md-95">
        <create-assistance-bill-form *ngIf="assistancecase && assistancecase?.id"
          [caseId]="assistancecase?.id" [ticket]="arrivedTicket" [disabled]="isDisabled"
          [country]="assistancecase?.country"
          (create)="onBillCreate($event)" (cancelEvent)="onBillCreateCancel()"
          (onLoadPrice)="onLoadPrice($event)" #newBillForm>
        </create-assistance-bill-form>
      </div>
    </div>
  </div>
</div>

<!-- VISTA DE BITACORA DE CLIENTE -->
<div class="cases-from" *ngIf="showClientView">
  <div class="card mt-3 mb-3">
    <div class="card-header-search color">
      <img alt="" class="go-to-back-title go-to-back-title2" (click)="showClientView = false; showDialogGeneral = true"
        [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">
      <p>{{ 'Customer log' | translate }}</p>
    </div>
    <div class="card-header-search padding">
      <div class="div-md-40">
        <textarea rows="20" class="form-control" [(ngModel)]="text_general" name="comment" readonly>
        </textarea>
      </div>
      <div class="div-vl"></div>
      <div class="div-md-30">
        <div class="form-group">
          <h2><strong>{{ 'Comment' | translate }}:</strong></h2>
          <div>
            <textarea rows="5" class="form-control" name="comment" [(ngModel)]="commentServiceConfig">
            </textarea>
          </div>
        </div>
      </div>
    </div>
    <!-- footer -->
    <div class="card-header-search brd">
      <div class="card-buttons-footer">
        <div class="card-left-footer">
        </div>
        <div class="card-right-footer">
          <button class="btn secundary-btn btn secundary-btn-fw"
            (click)="showDialogGeneral = true; showClientView = false"> {{ 'Cancel' | translate }} </button>
          <button class="btn primary-btn btn primary-btn-fw btn-margin" (click)="CommentOn()"> {{ 'Comment' | translate
            }} </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Assigned provider view -->
<div class="cases-from" *ngIf="showProviderView">
  <!--<img (click)="showProviderView = false; flagAssignProvider=false; showDialogGeneral = true" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">-->
  <div class="row" style="width: 95%; margin-left: 6%;">
    <div class="col-6">
      <div class="row">
        <div class="col-8">
          <h2 class="morfeo-title"><strong>{{'Provider coordination' | translate }}</strong></h2>
        </div> 
        <div class="col-4" style="padding: 1rem 1rem 0rem 0rem;">
          <button *ngIf="iAm([
            'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
            'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'quality'
          ])" (click)="showReasignProviderCard(service_id)" class="btn btn-light secundary-btn ms-2" [disabled]="!ticketProviderExists"  style="width: max-content; font-weight: bold;">{{ 'Reassign Provider' | translate }}</button>
        </div>
      </div>
      <div class="row">
        <div>
          <div class="card-body-search card-column-flex morfeo-card">
            <div class="row" *ngFor="let servicegroup of servicegroups">
              <div class="col-1 col-img">
                <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/datos_vehiculo.svg' | company">
              </div>
              <div class="col col-data">
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <p><strong>{{ 'Vehicle Data' | translate }}{{": "}}</strong>{{ servicegroup?.car_model?.brand.name }}{{" "}}{{ servicegroup?.car_model?.name }}</p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="row">
                      <p><strong>{{ 'Year' | translate }}{{": "}}</strong>{{servicegroup.car_year}} </p>
                    </div>
                  </div>                
                  <div class="col-6">
                    <div class="row">
                      <p><strong>#{{ 'Plate' | translate }}{{": "}}</strong>{{servicegroup.car_plate}} </p>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <div class="row">
                      <p><strong>#{{ 'Serie' | translate }}{{": "}}</strong>{{ servicegroup.car_serial_number }}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div class="row">
              <div class="col-1 col-img">
                <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/assistancecase/client_data.svg' | company" style="margin-left: 0.3rem;">
              </div>
              <div class="col col-data">
                <div class="row">
                  <p><strong>{{ 'Client Data' | translate }}{{": "}}</strong>{{ assistancecase?.member?.name | titlecase }}</p>
                </div>
                <div class="row">
                  <div class="col" style="display: flex;">
                    <p><strong>#{{ 'Phone' | translate }} :</strong></p>
                    <div style="text-decoration: underline; color: #70BE21;margin-left: 8px; cursor: pointer;"><strong>{{ phone }}</strong></div>
                    <div *ngIf="phone2" style="text-decoration: underline; color: #70BE21;margin-left: 8px; cursor: pointer;"><strong>{{ phone2 }}</strong></div>
                    <!--<img [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/edit.svg' | company"> -->
                  </div>
                </div>
              </div>
            </div>
            <hr style="width: 90%; margin-left: 5%; margin-top: 1rem;">
            <div class="row" *ngFor="let assistanceticket of assistancetickets">
              <div class="col col-data-margin" *ngIf="assistanceticket.ticket_type==1">
                <p><strong>{{ 'Comment' | translate }}</strong></p>
                <p>{{assistanceticket.comment}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" style="margin-top: 1rem;"> <!--margin to get the space between 2 cards-->
        <div>
          <div class="card-body-search card-column-flex morfeo-card">
            <div class="row row-padding">
              <div class="col-12">
                <p><strong>{{ 'Provider' | translate }}{{": "}}</strong> {{ provider?.name | titlecase }}</p>
              </div>
              <div class="col-12">
                <p><strong>{{ 'Provider Site' | translate }}:</strong> {{ provider_site?.equivalence_id }} - {{ provider_site?.site | titlecase }}</p>
              </div>
            </div>
            <div class="row row-padding" *ngIf="!unAssignedProvider">
              <div class="col">
                <p *ngIf="coverage && coverage.coverage_type == 1"><strong>{{provider2?.currency_symbol? provider2.currency_symbol : '$'}}{{ prices? prices.price_weekday : 0 }}</strong></p>
                <p *ngIf="coverage && coverage.coverage_type == 2"><strong>{{provider2?.currency_symbol? provider2.currency_symbol : '$'}}{{ prices? prices.price_weekday: 0 }}/Km</strong></p>
              </div>
              <div class="col">
                <div *ngFor="let price of coverage?.assistancePrices">
                  <span *ngIf="price.service_id == service_id">{{ "Cancellation" | translate }} {{ price?.price_cancellation }}%</span>
                </div>
              </div>
              <div class="col">
                <div *ngFor="let price of coverage?.assistancePrices">
                  <span *ngIf="price.service_id == service_id">{{provider2?.currency_symbol? provider2.currency_symbol : '$'}} {{ price?.price_extra != null ? price?.price_extra : '-'  }}/km</span>
                </div>
              </div>
              <div class="col-4">
                <p *ngIf="coverage && coverage.coverage_type == 1"><strong>{{coverage? coverage.name : 'N/A'}}</strong></p>
                <p *ngIf="coverage && coverage.coverage_type == 2"><strong>{{'Foreign' | translate}}</strong></p>
              </div>
              <div class="col-6" style="display: flex; align-items: center">
                <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/compass.svg' | company" style="width: 1.2rem">
                <p><strong>{{(provider_site? provider_site.state : '-') +', '+ (provider_site? provider_site.district : '-')}}</strong></p>
              </div>
              
            </div>
            <div class="row row-padding">
              <div class="col">
                <div *ngFor="let price of coverage?.assistancePrices">
                  <span *ngIf="price.service_id == service_id">{{ 'Description' | translate }}: </span>
                <span *ngIf="price.service_id == service_id">{{ price?.note }}</span>
                </div>
              </div>
            </div>
            <div class="row row-padding" *ngIf="unAssignedProvider">
              <p>{{ 'Unassigned' | translate }}</p>
            </div>
            <div class="row" *ngFor="let assistanceticket of assistancetickets">
              <div class="col" >
                <textarea class="textbox-comment" placeholder="{{ 'Type a comment...' | translate }}" disabled="true" *ngIf="assistanceticket.ticket_type==2  && assistanceticket.provider_status == 1">{{assistanceticket.comment}}</textarea>
              </div>
            </div>
            <div class="row row-btn" *ngIf="!unAssignedProvider">
              <div class="col">
                <button *ngIf="iAm([
                    'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
                    'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical', 'quality'
                  ])" class="btn primary-btn-green" style="width: 40%; margin-left:30%; font-weight: bold;">
                  <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company" style="margin-right: 1rem;">
                  {{ 'To call' | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row row-btn" style="margin-top: 1rem;">
        <button (click)="hideProviderCard()" class="btn secundary-btn" style="width:fit-content; padding: 0rem 2rem; font-weight: bold;">{{ 'Go to ticket' | translate }}</button>
      </div>
    </div>
    <div class="col-6" >
      <div class="row">
        <div class="card-body-search card-column-flex">
          <p-gmap
            [options]="mapOptions" [style]="{width:'100%', height:'90vh'}"
            [overlays]="mapOverlays" (onMapReady)="onMapReady($event)" #customerMap>
          </p-gmap>
        </div>
      </div>


      <div class="row">
        <div [ngClass]="have_coordinates ? 'col-md-8' : 'col-12'">
          <p-messages [enableService]="false" [(value)]="msgs" [closable]="false"></p-messages>
        </div>
      
        <div *ngIf="have_coordinates" class="col-md-4 d-flex align-items-center">
          <button 
            (click)="openLinkLocationCustomer()" 
            class="btn secundary-btn-green" 
            style="width: fit-content;">
            {{ 'Get client location' | translate }}
          </button>
        </div>
      </div>

      <!-- <div class="row row-btn">
        <button (click)="openLinkLocationCustomer()" class="btn secundary-btn-green" style="position: relative; margin-top:-6rem; width:fit-content;">{{ 'Get client location' | translate }}</button>
      </div> -->
    </div>
  </div>
</div>
<!-- POP UPS -->

<!-- PROVIDER NO ASIGNED MODAL-->
<p-dialog
  [(visible)]="showUnassignedModal"
  [responsive]="true" [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true">
  <div style="text-align: center;">
    <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/others/alert.svg' | company" style="width: 75%; aspect-ratio: 1/1;">
    <p>{{ 'Provider Not Assigned' | translate }}</p>
  </div>
</p-dialog>

<!-- REASING PROVIDER MODAL-->
<p-dialog
  header="{{ 'Reassign Provider' | translate }}" [(visible)]="showReassignProviderDialog"
  [responsive]="true" [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true">
  <app-assistance-reassign-provider
  [service]="case_service_id"
  [providers]="providers_re"
  [case_id]="case_id"
  #newForm>
  </app-assistance-reassign-provider>
</p-dialog>

<!-- OPCIONES DE CONFIGURACION DE SERVICIO Y EXCEPCION -->
<p-dialog [(visible)]="showPopUpMore" [modal]="true" [blockScroll]="true" [draggable]="false">
  <table style="width: 100%;" *ngFor="let servicegroup of servicegroups" aria-label="servicegrouptickettable">
   <th scope="col"></th>
    <tr style="background-color: #f9f9f9; cursor: pointer;">
      <td (click)="setException(servicegrouptickets[servicegroup.service_id]);
        showPopUpMore=false; showDialogGeneral=false">{{ 'Exception' | translate }}</td>
    </tr>
    <tr style="background-color: white; cursor: pointer;">
      <td (click)="setCourtesy(servicegrouptickets[servicegroup.service_id]);
        showPopUpMore=false">{{ 'Courtesy' | translate }}</td>
    </tr>
    <tr style="background-color: #f9f9f9; cursor: pointer;">
      <td (click)="setReimburse(servicegrouptickets[servicegroup.service_id]);
      showPopUpMore=false">{{ 'Reimburse' | translate }}</td>
    </tr>
  </table>
</p-dialog>

<!-- CONFIRMACION DE SERVICIO POR CONEXION -->
<p-dialog [(visible)]="showConfirmByConection" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [style]="{width: '40vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Service per connection' | translate }}
  
  </ng-template>
  
  <div class="mb-2">
    <strong>
      {{ 'Do you want to activate the service by connection?' | translate }}
    </strong>
  </div>
  <div class="tr-header-center">

    <form #connectionForm="ngForm" (ngSubmit)="onSetServiceByConection()">
      <div>
        <textarea rows="5" class="form-control" [(ngModel)]="commentServiceConfig"
          placeholder="{{ 'Write a comment' | translate }}" required name="ConnectionComment"
          #connectionComment="ngModel">
          </textarea>
        <br>
      </div>
      <div class="footer-btns">
        <button type="button" class="btn secundary-btn wa btn-margin"
          (click)="showConfirmByConection=false; showDialogGeneral=true">No</button>
        <button type="submit" [disabled]="reimburseForm.form.invalid || reimburseForm.form.pending"
          class="btn primary-btn wa btn-margin" type="submit">Si</button>
      </div>
    </form>
  </div>
</p-dialog>

<!-- CONFIRMACION DE SERVICIO POR RECORDINACION -->
<p-dialog [(visible)]="showConfirmByRecordination" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [style]="{width: '40vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Service per recordination' | translate }}
  
  </ng-template>
  
  <div class="mb-2">
    <strong>
      {{ 'Do you want to activate the service by recordination?' | translate }}
    </strong>
  </div>
  <div class="tr-header-center">

    <form #connectionForm="ngForm" (ngSubmit)="onSetServiceByRecordination()">
      <div>
        <textarea rows="5" class="form-control" [(ngModel)]="commentServiceConfig"
          placeholder="{{ 'Write a comment' | translate }}" required name="ConnectionComment"
          #connectionComment="ngModel">
          </textarea>
        <br>
      </div>
      <div class="footer-btns">
        <button type="button" class="btn secundary-btn wa btn-margin"
          (click)="showConfirmByRecordination=false; showDialogGeneral=true">No</button>
        <button type="submit" [disabled]="reimburseForm.form.invalid || reimburseForm.form.pending"
          class="btn primary-btn wa btn-margin" type="submit">Si</button>
      </div>
    </form>
  </div>
</p-dialog>

<!-- CONFIRMACION DE SERVICIO POR REEMBOLSO -->
<p-dialog [(visible)]="showConfirmByReimburse" [modal]="true" [blockScroll]="true" [draggable]="false"
  [style]="{width: '40vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Reimburse' | translate }}
  
  </ng-template>
  
  <div class="mb-2">
    <strong>
      {{ 'Do you want to activate the refund service?' | translate }}
    </strong>
  </div>
  <div class="tr-header-center">

    <form #reimburseForm="ngForm" (ngSubmit)="onSetServiceReimburse()">
      <div>
        <textarea rows="5" class="form-control" [(ngModel)]="commentServiceConfig"
          placeholder="{{ 'Write a comment' | translate }}" required name="ReimburseComment"
          #reimburseComment="ngModel">
      </textarea>
        <br>
      </div>
      <div class="footer-btns">
        <button type="button" class="btn secundary-btn wa btn-margin"
          (click)="showConfirmByReimburse=false; showDialogGeneral=true">No</button>
        <button [disabled]="reimburseForm.form.invalid || reimburseForm.form.pending"
          class="btn primary-btn wa btn-margin" type="submit">Si</button>
      </div>
    </form>
  </div>
</p-dialog>

<!-- LLAMADAS -->
<p-dialog [modal]="true" [blockScroll]="true" [draggable]="false" [closable]="false" *ngIf="servicegroups.length">

  <div>
    <h2><strong>{{ 'Confirm and select the phone number' | translate }}</strong></h2>
    <hr>
    <div class="btns-popup-call">
      <div class="form-check">
        <h2><strong>{{ assistancecase?.member?.name }}</strong></h2>
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="{{phone}}" value="{{phone}}">
        <label class="form-check-label" for="{{phone}}">
          <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company">
          {{ phone }}
        </label>

        <input *ngIf="phone2 != null ? true : false" class="form-check-input" type="radio" name="flexRadioDefault"
          id="{{phone2}}" value="{{phone2}}">
        <label *ngIf="phone2 != null ? true : false" class="form-check-label" for="{{phone2}}">
          <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company">
          {{ phone2 }}
        </label>

        <h2><strong>Gruas Bendi</strong></h2>
        <input class="form-check-input" type="radio" name="flexRadioDefault" id="{{phone}}" value="{{phone}}">
        <label class="form-check-label" for="{{phone}}">
          <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company">
          {{ phone }}
        </label>
      </div>
    </div>

    <hr>
    <div class="btns-popup-call">
      <div>
        <h2>{{ 'Other' | translate }}:</h2>
        <input>
      </div>
    </div>
    <hr>
    <div class="btns-popup-call">
      <button class="btn primary-btn-green px-4" *ngIf="!gettickettypefromGroup(servicegrouptickets[
              servicegroups[0].service_id
            ],5)">
        <img alt="" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company">
        {{ 'Call' | translate }}
      </button>
      <button class="btn secundary-btn-green btn-margin">
        {{ 'Cancel' | translate }}
      </button>
    </div>
  </div>
</p-dialog>


<!-- VIEJO -->

<div class="container-fluid" *ngIf="false">
  <div class="row">
    <div class="col-sm-12 title-panel">
      <div class="card full-width">
        <div class="col-sm-9">
          <h1>
            <a routerLink="/admin/assistance/cases/{{status}}/{{member_id}}">
              {{ 'Cases' | translate }}
            </a>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
            {{ 'Case' | translate }} #{{ case_id }} ({{ totalCount }})

            <button class="btn btn-success btn-sm" *ngIf="isAllowedToCreateReprocess()" (click)="showReprocessForm()">
              <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
              {{ 'Add New Reprocess' | translate }}
            </button>
            <a [routerLink]="'/admin/assistance/reprocesses'" [queryParams]="{assistance_case_id: case_id}" *ngIf="iAm([
                'assistance_admin', 'supervisor', 'networkleader',
                'quality'
              ])" class="btn btn-default btn-sm">
              {{ 'Reprocesses' | translate }}
            </a>
            <button class="btn btn-primary btn-sm" *ngIf="isAllowedToCreateReprocess()" (click)="finishReprocesses()">
              <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
              {{ 'Finish Reprocesses' | translate }}
            </button>



            <button (click)="activateClientInformation()" class="btn btn-success btn-sm">
              {{'Client Information' | translate}}
            </button>

            <button *ngFor="let importFile of images" class="btn btn-success btn-sm"
              (click)="showPreviewAttachment(importFile)">

              {{ 'Show letter' | translate }}
            </button>



            <button class="btn btn-primary btn-sm" *ngIf="gettickettypefromGroup(servicegrouptickets[
              servicegroups[0].service_id
            ],4)" (click)="viewsurveyoptions()">
              <i class="fa fa-file-text-o" aria-hidden="true"></i>
              {{ 'Send Survey' | translate }}
            </button>
            <button class="btn btn-primary btn-sm" *ngIf="gettickettypefromGroup(servicegrouptickets[
            servicegroups[0].service_id
          ],5)"	
            (click)="viewsurveyoptions()">
            <i class="fas fa-play-circle" aria-hidden="true"></i>
            {{ 'Listen to audio' | translate }}
          </button>
          </h1>
        </div>
        <div style="padding-top: 8px;" class="col-sm-3">
        </div>

        <div class="col-sm-12 case-info-container">
          <div class="col-sm-5 case-info-panel">
            <div *ngIf="assistancecase && assistancecase?.id">
              <table aria-label="operatortable">
                <th scope="col"></th>
                <tr>
                  <td>
                    <div>
                      {{ 'Operator' | translate }}:
                      <strong>{{ assistancecase?.created_by_user?.username || "---" }}</strong>
                    </div>
                  </td>
                  <td>
                    <strong>{{'Additional Information'| translate}}</strong>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Dispatcher' | translate }}:
                      <strong>{{ assistancecase?.created_by?.username || "---" }}</strong>
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ 'Max Amount per Event' | translate }}:
                      <strong style="color: red;">{{additionalplanservice.max_amount}}</strong>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Country' | translate }}:
                      <strong>{{ assistancecase?.country.name}}</strong>
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ 'Max Amount by Period' | translate }}:
                      <strong style="color: red;">{{additionalplanservice.max_amount_general}}</strong>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'State District' | translate }}:
                      <strong *ngIf="assistancecase?.stateDistrict">
                        {{ assistancecase?.stateDistrict.name}}
                      </strong>
                    </div>
                  </td>
                  <td>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Zone' | translate }}:
                      <strong>{{ assistancecase?.zone}}</strong>
                    </div>
                  </td>
                  <td>
                    <div>
                      Disponible:
                      <strong style="color: red;">{{disponible}}</strong>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Area' | translate }}:
                      <strong>{{ assistancecase?.area}}</strong>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Product' | translate }}:
                      <strong>
                        {{ assistancecase?.product?.name}}
                      </strong>
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ 'Territoriality' | translate }}:
                      <strong>{{additionalplanservice.territoriality}}</strong>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Plan' | translate }}:
                      <strong>
                        {{ assistancecase?.plan?.name}} : {{ assistancecase?.plan?.id}}
                      </strong>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div>
                      <span>
                        {{ 'Type of Services' | translate }}:
                      </span>
                      <strong style="display: inline-grid;">
                        <span *ngFor="let serviceCategory of serviceCategories">
                          {{ serviceCategory }}
                        </span>
                      </strong>
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ 'Emergency reporting time' | translate }}:
                      <strong>{{additionalplanservice.emergency_reporting_time}}h</strong>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Sale Name' | translate }}:
                      <strong>{{ assistancecase?.member.name }}</strong>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Sale No. ID' | translate }}:
                      <strong>{{ assistancecase?.member.national_id }}</strong>
                    </div>
                  </td>
                  <td></td>
                </tr>
                <tr>
                  <td>
                    <div>
                      {{ 'Dependent not reported' | translate }}:
                      <strong>{{ assistancecase?.applicant_name || "---" }}</strong>
                    </div>
                  </td>
                  <td></td>
                </tr>
              </table>









            </div>
            <!--esta-->
            <table class="form-case-table" [class.full-table]="editaddressFlag" aria-label="phonetable">
              <th scope="col"></th>
              <tbody>
                <tr>
                  <td>
                    {{ 'Phone' | translate }}:
                  </td>
                  <td *ngIf="editphoneFlag==false">
                    <strong>{{ phone }}</strong>
                  </td>
                  <td>
                    <input type="text" class="input1" onFocus="this.select()" name="phone" [(ngModel)]="phone">
                  </td>
                  <td *ngIf="editphoneFlag">
                  </td>
                  <td>
                    <a (click)="editCasephone()" *ngIf="iAm([
                        'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
                        'networkleader'
                      ])">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>
                    {{ 'Phone' | translate }} 2:
                  </td>
                  <td *ngIf="editphone2Flag==false">
                    <strong>{{ phone2 }}</strong>
                  </td>
                  <td>
                    <input type="text" class="input3" onFocus="this.select()" name="phone2" [(ngModel)]="phone2">
                  </td>
                  <td *ngIf="editphone2Flag">
                  </td>
                  <td>
                    <a (click)="editCasephone2()" *ngIf="iAm([
                        'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
                        'networkleader'
                      ])">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>



                <tr>
                  <td>
                    {{ 'Email' | translate }}:
                  </td>
                  <td *ngIf="editemailFlag==false">
                    <strong>{{ email_ }}</strong>
                  </td>
                  <td>
                    <input type="text" class="input5" onFocus="this.select()" name="email" [(ngModel)]="email_">
                  </td>
                  <td *ngIf="editemailFlag">
                  </td>
                  <td>
                    <a (click)="editCaseemail()" *ngIf="iAm([
                        'assistance_admin', 'supervisor', 'operator',
                        'networkleader'
                      ])">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ 'Address' | translate }}:
                  </td>
                  <td *ngIf="editaddressFlag==false">
                    <strong>{{ address }}</strong>
                  </td>
                  <td [class.textarea-address]="editaddressFlag">
                    <textarea rows="3" class="input2" onFocus="this.select()" name="address" [(ngModel)]="address">
                    </textarea>
                  </td>
                  <td *ngIf="editaddressFlag">
                  </td>
                  <td>
                    <a (click)="editCaseaddress()" *ngIf="iAm([
                        'assistance_admin', 'supervisor','operator', 'cabin_agent',
                        'networkleader'
                      ])">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ 'Address registered by customer' | translate }}:
                  </td>
                  <td *ngIf="editaddressFlag==false">
                    <strong>{{ complete_address }}</strong>
                  </td>
                  <td [class.textarea-address]="editaddressFlag">
                    <textarea rows="3" class="input2" onFocus="this.select()" name="address" [(ngModel)]="address">
                    </textarea>
                  </td>
                  <td *ngIf="editaddressFlag">
                  </td>
                  <td>
                    <a (click)="editCaseaddress()" *ngIf="iAm([
                        'assistance_admin', 'supervisor','operator',
                        'networkleader'
                      ])">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
                <tr>               
                  <div  *ngFor = "let importFile of images">                   
               </div>              
                </tr>
                <tr>
                  <td *ngIf="showDestinationAddress">
                    {{'Arrive to Address' | translate}}:
                  </td>
                  <td *ngIf="showDestinationAddress">
                    <strong>{{ service_address }}</strong>
                  </td>
                </tr>
                <tr *ngIf="assistancecase && ((assistancecase?.status == 2)
                    && (assistancecase?.rating_status == 1))">
                  <td>
                    {{ 'Member Comment' | translate }}:
                  </td>
                  <td>
                    <strong>{{ assistancecase?.member_comment}}</strong>
                  </td>
                  <td>

                  </td>
                </tr>
                <tr *ngIf="(editaddressFlag==true
                    ||editphoneFlag==true||editphone2Flag==true  || editemailFlag==true)
                    && iAm([
                      'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader'
                    ])">
                  <td></td>
                  <td></td>
                  <td></td>
                  <td>
                    <button class="btn btn-primary btn-sm" (click)="updateCaseinfo()">
                      {{ 'Save' | translate }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-sm-7">
            <div class="ticketmap">

            </div>
          </div>
        </div>


      <div class="audios" *ngIf="iAm(['assistance_admin', 'supervisor', 'quality','networkleader'])">
      <div class="col-sm-12" >
        <h1>{{ 'Case calls' | translate }}</h1>
          <img alt="" *ngIf="audioFlag" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/loading_gif/loader.gif' | company"/>
          <p *ngIf="caseAudios?.length == 0">
            {{ 'No audios available' | translate }}
          </p>
        <table *ngIf="caseAudios?.length != 0" class="table-condensed table-hover" aria-label="calltimetable">
          <thead  style="background:#f9f9f9">
            <tr>
              <th scope="col">{{ 'Call time' | translate }}</th>
              <th scope="col">{{ 'Reason' | translate }}</th>
              <th scope="col">{{ 'User last name' | translate }}</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let audio of caseAudios">
              <td>
                {{ audio?.startTime }}
              </td>
              <td>
                {{ audio?.agentDispositionName }}
              </td>
              <td>
                {{ audio?.callerLastName }}
              </td>
              <td>
                <button *ngIf="audio?.showButton" class="btn btn-success" (click)="getAudio(audio?.pkId)">
                  {{ 'Search Audio' | translate }}
                </button>
                <audio controls *ngIf="audio?.showAudio">
                  <source src={{audio?.audioURL}} type="audio/wav">
                </audio>
              </tr>
            </tbody>
          </table>
          <br>
        </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-sm-12 services-panel">
      <div class="col-sm-12 card service-panel" *ngFor="let servicegroup of servicegroups">
        <div class="card-container">
          <div class="col-sm-12">
            <h3>
              <span *ngIf="servicegroup.service.category.id==2">
                <i class="fa fa-car" aria-hidden="true"></i>
              </span>
              <span *ngIf="servicegroup.service.category.id==3">
                <i class="fa fa-ambulance" aria-hidden="true"></i>
              </span>
              <span *ngIf="servicegroup.service.category.id==4">
                <i class="fa fa-home" aria-hidden="true"></i>
              </span>
              <span *ngIf="servicegroup.service.category.id==5">
                <i class="fa fa-balance-scale" aria-hidden="true"></i>
              </span>
              <span *ngIf="servicegroup.service.category.id==6">
                <i class="fa fa-briefcase" aria-hidden="true"></i>
              </span>
              <span *ngIf="servicegroup.service.category.id==16">
                <i class="fa fa-user-md" aria-hidden="true"></i>
              </span>
              <span *ngIf="servicegroup.service.category.id==8">
                <i class="fa fa-bell-0" aria-hidden="true"></i>
              </span>
              <span *ngIf="servicegroup.service.category.id==9">
                <i class="fa fa-briefcase" aria-hidden="true"></i>
              </span>
              <span>{{ servicegroup.service.name }}</span>
              <div class="group-provider-panel">
                <span *ngIf="goprovider[servicegroup.service_id]">
                  {{ goprovider[servicegroup.service_id].name }}:
                  {{ goprovider[servicegroup.service_id].contact_phones}}
                </span>
                <div class="filters-added-panel">
                  <span *ngIf="servicegroup.car_model" class="filter">
                    <span class="lbl">
                      {{ 'Car Brand' | translate }}:
                    </span>
                    <span class="value" *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2; else elsebrand">
                      {{ assistanceSaleCar?.brand_description }}
                    </span>
                    <ng-template #elsebrand>
                      <span class="value">
                        {{ servicegroup.car_model.brand.name }}<span class="comma">,</span>
                      </span>
                    </ng-template>
                  </span>
                  <span *ngIf="servicegroup.car_model" class="filter">
                    <span class="lbl">
                      {{ 'Car Model' | translate }}:
                    </span>
                    <span class="value" *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2; else elsemodel">
                      {{ assistanceSaleCar?.model_description }}
                    </span>
                    <ng-template #elsemodel>
                      <span class="value">
                        {{ servicegroup.car_model.name }}<span class="comma">,</span>
                      </span>
                    </ng-template>
                  </span>
                  <span *ngIf="servicegroup.car_year" class="filter">
                    <span class="lbl">
                      {{ 'Car Year' | translate }}:
                    </span>
                    <span class="value" *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2; else elseyear">
                      {{ assistanceSaleCar?.car_year }}
                    </span>
                    <ng-template #elseyear>
                      <span class="value">
                        {{ servicegroup.car_year }}<span class="comma">,</span>
                      </span>
                    </ng-template>
                  </span>
                  <span *ngIf="servicegroup.car_plate" class="filter">
                    <span class="lbl">
                      {{ 'Car Plate' | translate }}:
                    </span>
                    <span class="value" *ngIf="additionalplanservice.sinister_apply === 1 && servicegroup.service.category.id==2; else elseplate">
                      {{ assistanceSaleCar?.car_plate }}
                    </span>
                    <ng-template #elseplate>
                      <span class="value" >
                        {{ servicegroup.car_plate }}<span class="comma">,</span>
                      </span>
                    </ng-template>
                  </span>
                  <span *ngIf="servicegroup.color_description || servicegroup.car_color_desc || servicegroup.car_color" class="filter">
                    <span class="lbl">
                      {{ 'Car Color' | translate }}:
                    </span>
                    <span class="value">
                      {{ servicegroup.color_description || servicegroup.car_color_desc }}<span class="comma">,</span>
                    </span>
                  </span>
                </div>
              </div>
              <button *ngIf="ticketbtnshow[servicegroup.service_id]==true" class="btn btn-success btn-sm"
                [disabled]="stepperReadOnly" (click)="startCreategroupTicket(servicegrouptickets[
                  servicegroup.service_id
                ])">
                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                <span *ngIf="!stepperReadOnly">
                  {{ 'Ticket' | translate }} {{ servicegroup.service.name }}
                </span>
                <span *ngIf="stepperReadOnly">
                  {{ "Waiting provider" | translate }}...
                </span>
              </button>
              <button [disabled]="!cancelprovider[servicegroup.service_id]"
                *ngIf="showCancelBtn[servicegroup.service_id]" class="btn btn-success btn-sm"
                (click)="ticketCancel(servicegrouptickets[servicegroup.service_id])">
                {{ 'Cancel' | translate }} {{ servicegroup.service.name }}
              </button>
             
              <!--Ticket de autorizacion de no consumo-->
              <button class="btn btn-success btn-sm" *ngIf="iAm([
                  'assistance_admin', 'supervisor'
                ])" (click)="setCourtesy(servicegrouptickets[servicegroup.service_id])">
                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                {{ 'Courtesy' | translate }}
              </button>
              <button class="btn btn-success btn-sm" *ngIf="iAm([
                  'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader',
                  'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'
                ])" (click)="setComment(servicegrouptickets[servicegroup.service_id])">
                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                {{ 'Comment' | translate }}
              </button>
              <button class="btn btn-success btn-sm" [disabled]="!provider_id" (click)="showProviderCard()">
                <i class="fa fa-search fa-fw" aria-hidden="true"></i>
                {{ 'Show Provider Information' | translate }}
              </button>
              <button class="btn btn-default btn-sm" *ngIf="iAm([
                  'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
                  'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'
                ])" (click)="setServiceconfig(servicegrouptickets[servicegroup.service_id])">
                {{ 'Service Configuration' | translate }}
              </button>
              <button class="btn btn-warning btn-sm"
                (click)="setException(servicegrouptickets[servicegroup.service_id])">
                <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                {{ 'Exception' | translate }}
              </button>

              <button *ngIf="ticketbtnshow[servicegroup.service_id]==true
                  && iAm([
                    'assistance_admin', 'supervisor', 'operator', 'cabin_agent',
                    'networkleader', 'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'
                  ])" class="btn btn-danger btn-sm" (click)="closeTicket(
                  servicegroup.service_id,servicegrouptickets[servicegroup.service_id]
                )">
                {{ 'Close Ticket' | translate }}
                {{ servicegroup.service.name }}
              </button>
            </h3>
          </div>
          <div *ngIf="iAm([
              'assistance_admin', 'supervisor', 'operator', 'cabin_agent', 'networkleader',
              'assistance_dispatcher', 'assistance_dispatcher_vial', 'assistance_dispatcher_medical'
            ])" class="col-sm-12">
            <app-assistance-tickets-step [totalCount]="totalCount"
              [grouptickets]="servicegrouptickets[servicegroup.service_id]" [categories]="assistancecategories"
              [countries]="countries" [flagAssignProvider]="flagAssignProvider"
              [showstep]="showstep[servicegroup.service_id]" [assistancecase]="assistancecase"
              [caseLocation]="caseLocation" [disabled]="isDisabled" [disableallstep]="disableallstep"
              [sale_canceled]="sale_canceled" [titular_name]="assistancecase?.member?.name" [tel]="phone"
              [readonly]="stepperReadOnly" [tipo_servicio]="serviceCategories[0]"
              [usuario_asesor]="assistancecase?.created_by?.username" [copago]="copago" [pago_copago]="pago_copago"
              (notifyAssignProviderView)="notifyAssignProviderView()" (update)="onTicketCreate($event)"
              (setUserProvider)="gotUserProvider($event)" (activeIndexReady)="onStepsActiveIndexReady(
                $event, servicegroup.service_id
              )"
              [inlatitude]="assistancecase.latitude" [inlongitude]="assistancecase.longitude" 
              
              >
            </app-assistance-tickets-step>
          </div>

          <div class="col-sm-12 timers-panel">
            <div class="timer-panel col-sm-4">
              <app-elapsedticket-time [starttime]="assistancecase?.date_start"
                [endtime]="clientEndTime[servicegroup.service_id]" [title]="'Client Perspective'">
              </app-elapsedticket-time>
            </div>
            <div class="timer-panel col-sm-4">
              <app-elapsedticket-time [starttime]="providerStartTime[servicegroup.service_id]"
                [endtime]="providerEndTime[servicegroup.service_id]" [title]="'Provider Assignment232323'">
              </app-elapsedticket-time>
            </div>
            <div class="timer-panel col-sm-4" *ngIf="ArrivalStartTime[servicegroup.service_id]">
              <app-elapsedticket-time [starttime]="ArrivalStartTime[servicegroup.service_id]"
                [endtime]="ArrivalEndTime[servicegroup.service_id]" [title]="'Provider Arrival'">
              </app-elapsedticket-time>
            </div>
          </div>

          <div class="table-responsive col-sm-12" aria-label="sortdatetable">
            <table class="table table-condensed table-hover tickets-table" aria-label="datetable">
              <thead>
                <tr style="background:#f9f9f9">
                  <th scope="col">
                  </th>
                  <th scope="col" (click)="sort_date_desc = !sort_date_desc;">
                    {{ 'Date' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'User' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'Type' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'Provider' | translate }}
                  </th>
                  <th scope="col" class="comment">
                    {{ 'Comment' | translate }}
                  </th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody *ngIf="sort_date_desc">
                <tr *ngFor="let assistanceticket of
                    servicegrouptickets[servicegroup.service_id] ">
                  <td>
                    <i *ngIf="assistanceticket.communication==1;" class="fa fa-phone" type="text" pTooltip="Phone"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==2;" class="fa fa-android" type="text" pTooltip="App"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==3;" class="fa fa-commenting-o" type="text" pTooltip="Chat"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==4;" class="fa fa-whatsapp" type="text" pTooltip="WhatsApp"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==5;" class="fa fa-envelope-o" type="text" pTooltip="Email"
                      tooltipPosition="left">
                    </i>
                  </td>
                  <td class="no-wrap">
                    <span>
                      {{
                      assistanceticket.datetime
                      | currentDate: {offset:hourTimeZone}
                      | date:'d MMM, hh:mm a'
                      }}
                    </span>
                  </td>
                  <td>
                    {{ assistanceticket.user? assistanceticket.user.username: '' }}
                  </td>
                  <td>
                    <span *ngIf="assistanceticket.ticket_type==1;">
                      {{'Assign Service' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==2;">
                      {{'Assign Provider' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==3;">
                      {{'Notify to customer' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==4;">
                      {{'Provider Arrived' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==50;">
                      {{'Arrival registered from the app' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==5;">
                      {{'Closed' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==6;">
                      {{'Canceled by Supervisor' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==7;">
                      {{'Canceled by Client' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT;">
                      {{'Service by reimbursement' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==8;">
                      {{'Canceled by Provider' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==9;">
                      {{'Comment' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==10;">
                      {{ 'Canceled by Client, Without Cost' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==11;">
                      {{'Programmed' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==12;">
                      {{'By Connection' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==14;">
                      {{'Exception' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==15;">
                      {{'Reimburse' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==22;">
                      {{'Courtesy' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==16;">
                      {{'Notify to customer' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==17;">
                      {{'Assign / Unassign' | translate }} 
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==35;">
                      {{'Cabin Exception' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==36;">
                      {{'Cabin Exception Authorization' | translate }}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="assistanceticket.provider_id">
                      {{assistanceticket.provider.name}}
                    </span>
                  </td>

                  <td class="comment">
                    <span *ngIf= "assistanceticket.triage == 1" >{{'Red' | translate}}</span>
                    <span *ngIf= "assistanceticket.triage == 2" >{{'Yellow' | translate}}</span>
                    <span *ngIf= "assistanceticket.triage == 3" >{{'Green' | translate}}</span>
                    <span *ngIf= "assistanceticket.triage == null" >{{' ' | translate}}</span>
                  </td>
                
                  
                  <td class="comment">
                    <div>
                      <span>{{assistanceticket.comment}}</span>
                    </div>
                  </td>
                  <td>
                    <a *ngIf="editbtnshow[servicegroup.service_id]==true
                        && assistanceticket.ticket_type != 16
                        && assistanceticket.ticket_type != 17
                        && assistanceticket.ticket_type != 1
                        && assistanceticket ===
                          servicegrouptickets[servicegroup.service_id][0]" (click)="editComment(assistanceticket)">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                    <a *ngIf="assistanceticket.ticket_type==4;" (click)="editDate()">
                      <i class="fa fa-calendar-check-o" aria-hidden="true" *ngIf="iAm(['assistance_admin']);"></i>
                    </a>
                    <a *ngIf="assistanceticket.ticket_type==14;" (click)="openExceptionDialog(assistanceticket)">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
              </tbody>

              <tbody *ngIf="!sort_date_desc">
                <tr *ngFor="let assistanceticket of
                    servicegrouptickets[servicegroup.service_id].slice().reverse() ">
                  <td>
                    <i *ngIf="assistanceticket.communication==1;" class="fa fa-phone" type="text" pTooltip="Phone"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==2;" class="fa fa-android" type="text" pTooltip="App"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==3;" class="fa fa-commenting-o" type="text" pTooltip="Chat"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==4;" class="fa fa-whatsapp" type="text" pTooltip="WhatsApp"
                      tooltipPosition="left">
                    </i>
                    <i *ngIf="assistanceticket.communication==5;" class="fa fa-envelope-o" type="text" pTooltip="Email"
                      tooltipPosition="left">
                    </i>
                  </td>
                  <td class="no-wrap">
                    <span>
                      {{
                      assistanceticket.datetime
                      | currentDate: {offset:hourTimeZone}
                      | date:'d MMM, hh:mm a'
                      }}
                    </span>
                  </td>
                  <td>
                    {{ assistanceticket.user? assistanceticket.user.username: '' }}
                  </td>
                  <td>
                    <span *ngIf="assistanceticket.ticket_type==1;">
                      {{'Assign Service' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==2;">
                      {{'Assign Provider' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==3;">
                      {{'Notify to customer' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==4;">
                      {{'Provider Arrived' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==50;">
                      {{'Arrival registered from the app' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==5;">
                      {{'Closed' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==6;">
                      {{'Canceled by Supervisor' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==7;">
                      {{'Canceled by Client' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==ticketSvc.CANCELED_SERVICE_BY_REIMBURSEMENT;">
                      {{'Service by reimbursement' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==8;">
                      {{'Canceled by Provider' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==9;">
                      {{'Comment' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==10;">
                      {{ 'Canceled by Client, Without Cost' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==11;">
                      {{'Programmed' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==12;">
                      {{'By Connection' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==14;">
                      {{'Exception' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==15;">
                      {{'Reimburse' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==16;">
                      {{'Notify to customer' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==17;">
                      {{'Assign / Unassign' | translate }} 
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==35;">
                      {{'Cabin Exception' | translate }} 
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==35;">
                      {{'Cabin Exception' | translate }} 
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==36;">
                      {{'Cabin Exception Authorization' | translate }}
                    </span>
                    <span *ngIf="assistanceticket.ticket_type==36;">
                      {{'Cabin Exception Authorization' | translate }}
                    </span>
                  </td>
                  <td>
                    <span *ngIf="assistanceticket.provider_id">
                      {{assistanceticket.provider.name}}
                    </span>
                  </td>

                  <td class="comment">
                    <span *ngIf= "assistanceticket.triage == 1" >{{'Red' | translate}}</span>
                    <span *ngIf= "assistanceticket.triage == 2" >{{'Yellow' | translate}}</span>
                    <span *ngIf= "assistanceticket.triage == 3" >{{'Green' | translate}}</span>
                    <span *ngIf= "assistanceticket.triage == null" >{{' ' | translate}}</span>
                  </td>
                
                  
                  <td class="comment">
                    <div>
                      <span>{{assistanceticket.comment}}</span>
                    </div>
                  </td>
                  <td>
                    <a *ngIf="editbtnshow[servicegroup.service_id]==true
                        && assistanceticket.ticket_type != 16
                        && assistanceticket.ticket_type != 17
                        && assistanceticket.ticket_type != 1
                        && assistanceticket ===
                          servicegrouptickets[servicegroup.service_id][0]" (click)="editComment(assistanceticket)">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </a>
                    <a *ngIf="assistanceticket.ticket_type==4;" (click)="editDate()">
                      <i class="fa fa-calendar-check-o" aria-hidden="true" *ngIf="iAm(['assistance_admin']);"></i>
                    </a>
                    <a *ngIf="assistanceticket.ticket_type==14;" (click)="openExceptionDialog(assistanceticket)">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>





  </div>
  <!--show update table of case-->
  <div class="row last-row case-changes-panel">
    <div *ngIf="updatecases.length>0" class="col-sm-12">
      <div class="card">
        <div class="card-container">
          <h3>
            {{ 'Case Changes' | translate }}
          </h3>

          <div class="table-responsive">
            <table class="table table-condensed table-hover" style="width: auto;" aria-label="dateusertable">
              <thead>
                <tr style="background:#f9f9f9">
                  <th scope="col">
                    {{ 'Date' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'User' | translate }}
                  </th>
                  <th scope="col" > 
                    {{ 'Field' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'Old' | translate }}
                  </th>
                  <th scope="col">
                    {{ 'New' | translate }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let updatecase of updatecases">
                  <td>
                    <span>
                      {{updatecase.update_date | date:'short'}}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{updatecase.user.name}}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{updatecase.item_name}}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{updatecase.value_old}}
                    </span>
                  </td>
                  <td>
                    <span>
                      {{updatecase.value_new}}
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<!--provider bills dialog -->

<p-popover #billInfo [dismissable]="true">
  <app-assistance-bill-info [setAssistancePrice]="billprice">
  </app-assistance-bill-info>
</p-popover>





<!--comment dialog -->
<p-dialog header="{{ 'Comment' | translate }}" [(visible)]="showCommentDialog" [responsive]="true" [modal]="true"
  [draggable]="false" [breakpoint]="500" [blockScroll]="true">
  <app-assistance-tickets-comment [Ticket]="commentTicket" [editFlag]="editcommentflag" [disabled]="isDisabled"
    (update)="onTicketUpdate($event)" (create)="onTicketCreate($event)" (cancelEvent)="onCancelEdit()" #newForm>
  </app-assistance-tickets-comment>
</p-dialog>

<!--letter dialog 
<p-dialog header="{{ 'Letter of Authorization' | translate }}" [(visible)]="showletter" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500" [blockScroll]="true">
  <app-assistance-letterauthorization [case_id]="case_id" [titular_name]="assistancecase?.member?.name" [opcion]="1"
    [applicant_name]="applicant_name" [applicant_id]="applicant_id" [country]="country">


  </app-assistance-letterauthorization>

</p-dialog>-->



<!--VISTA DE EDITAR CASO MANUAL-->

<div *ngIf="showeditManual">
  <div class="container-fluid">
    <div class="container-morfeo">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-container">
              <div class="title-panel">
                <img alt="" class="go-to-back-title" (click)="hideletter();" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">

                
                <h1>
                  {{ 'Edit Assistance Case' | translate }}
                </h1>
              </div>

              <div class="p-4">
                <div>
                  <div class="cases-from">
                    <div class="card">
                      <form class="form-horizontal" (ngSubmit)="searchMemberSales($event)" #searchForm="ngForm">
                        <div class="card-body after">
                          <!-- Country -->
                          <div class="margin-width-form after ctry">
                            <label>{{ "Country" | translate }}</label>
                            <select #search_country_id  name="country" class="form-control mw after"
                              (ngModelChange)="onSelectCountry($event)" [(ngModel)]="country_id" required>
                              <!-- <option [ngValue]="null">---</option> -->
                              <option *ngFor="let country of countries" [ngValue]="country.id">
                                <app-flags class="flag-position" [country]="country"></app-flags>
                                {{ country.name }}
                              </option>
                            </select>
                          </div>
              
                          <!-- Search Type -->
                          <div class="margin-width-form after">
                            <label>{{ "Type Search" | translate }}</label>
                            <select #search_type name="typeSearch" class="form-control after" [(ngModel)]="typeSearch"
                              (ngModelChange)="changeTypeSearch($event)" required>
                              <!-- <option [ngValue]="TYPE_SEARCH.COVER_LETTER">
                                {{ "Coverage Letter" | translate }}
                              </option> -->
                              <option [ngValue]="9">
                                {{ "Search by name" | translate }}
                              </option>
                              <option [ngValue]="11">
                                {{ "Search by national ID" | translate }}
                              </option>
                              <option [ngValue]="12">
                                {{ "Search by phone" | translate }}
                              </option>
                              <option [ngValue]="10">
                                {{ "Assistance Code" | translate }}
                              </option>
                              <!-- <option [ngValue]="TYPE_SEARCH.POLICY">
                                {{ "Policy" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.REFERENCE">
                                {{ "Reference" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.RFC">
                                {{ "Tax identification" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.SERIE">
                                {{ "Serie" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.PHONE">
                                {{ "Phone" | translate }}
                              </option> -->
                              <!-- <option [ngValue]="TYPE_SEARCH.BY_CONECTION">
                                {{ "By Connection" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.MANUAL_CASE">
                                {{ "Manual Case" | translate }}
                              </option> -->
                              <option [ngValue]="TYPE_SEARCH.CAR_PLATE">
                                {{ "Search by car plate" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.CAR_ENGINE_NUMBER">
                                {{ "Search by car engine number" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.CAR_SERIAL_NUMBER">
                                {{ "Search by car serial number" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.EMAIL">
                                {{ "Search by Email" | translate }}
                              </option>
                              <option [ngValue]="TYPE_SEARCH.TAX_NUMBER">
                                {{ "Search by Tax Identification Number" | translate }}
                              </option>
                            </select>
                          </div>
              
                          
                          <!-- Poliza -->
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 9">
                            <div class="margin-div-form">
                              <label>{{ 'Client' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>
                          <!-- Search with assistance code -->
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 10">
                            <div class="margin-div-form">
                              <label>{{ 'Assistance Code' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 11">
                            <div class="margin-div-form">
                              <label>{{ 'National ID' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 12">
                            <div class="margin-div-form">
                              <label>{{ 'Phone' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 99">
                            <div class="margin-div-form">
                              <label>{{ 'Car Plate' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 50">
                            <div class="margin-div-form">
                              <label>{{ 'Engine number' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 55">
                            <div class="margin-div-form">
                              <label>{{ 'Serial number' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>
                          <div class="margin-width-form mw after" *ngIf="typeSearch == TYPE_SEARCH.EMAIL">
                            <div class="margin-div-form">
                              <label>{{ 'Email' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>



                          <div class="margin-width-form mw after" *ngIf="typeSearch == TYPE_SEARCH.TAX_NUMBER">
                            <div class="margin-div-form">
                              <label>{{ 'Tax Identification Number' | translate }}</label>
                              <input
                                [required] = "true"
                                type="text"
                                name="membername"
                                class="form-control mmww after"
                                #membername="ngModel"
                                [disabled]="isMemberDisabled"
                                [(ngModel)]="member_name"
                                placeholder="{{ 'Search...' | translate }}"
                              >
                            </div>
                          </div>

                          <!-- Poliza -->
                          <div class="margin-width-form mw after" *ngIf="typeSearch == 3">
                            <!-- Clave -->
                            <div>
                              <label>{{ "Key" | translate }}</label>
                              <input #search_key name="search_key" required placeholder="{{ 'Key' | translate }}"
                                class="form-control mmw after" [(ngModel)]="key" />
                            </div>
              
                            <!-- Poliza -->
                            <div>
                              <label>{{ "Policy" | translate }}</label>
                              <input #search_policy name="search_policy" required placeholder="{{ 'Policy' | translate }}"
                                class="form-control mmw after" [(ngModel)]="policy" />
                            </div>
              
                            <!-- Inicio -->
                            <div>
                              <label>{{ "Incised" | translate }}</label>
                              <input #search_inciso name="search_inciso" required placeholder="{{ 'Incised' | translate }}"
                                class="form-control mmw after" [(ngModel)]="inciso" />
                            </div>
                          </div>
              
                          <!-- Carta Cobertura -->
                          <div class="margin-width-form mw after-2" *ngIf="typeSearch == 1">
                            <app-members-search
                              
                              
                              [placeholder]="'Search by name, phone, national ID'"
                              [country_id]="countryy.id"
                              
                              [disabled]="isMemberDisabled"
                              [member]="assistancecase?.member"
                              
                              [isCase]="true">
                            </app-members-search>
                            <!-- <div class="margin-div-form">
                              <label>{{ "Company name" | translate }}</label>
                              <input #search_company name="search_company" required placeholder="{{ 'Company name' | translate }}"
                                class="form-control mmww after" [(ngModel)]="companyName" />
                            </div> -->
                          </div>
              
                          <!-- Carta Cobertura -->
                          <!-- <div class="margin-width-form mw after-2" *ngIf="
                              typeSearch != 3 &&
                              typeSearch != 1 &&
                              typeSearch != 9 &&
                              typeSearch != 10 &&
                              typeSearch != 11 &&
                              typeSearch != 12 &&
                              typeSearch != TYPE_SEARCH.BY_CONECTION &&
                              typeSearch != TYPE_SEARCH.MANUAL_CASE
                            ">
                            <div class="margin-div-form">
                              <label *ngIf="typeSearch == 2">{{ 'Name' | translate }}</label>
                              <label *ngIf="typeSearch == 4">{{ 'Reference' | translate }}</label>
                              <label *ngIf="typeSearch == 5">{{ 'Tax identification' | translate }}</label>
                              <label *ngIf="typeSearch == 6">{{ 'Serie' | translate }}</label>
                              <label *ngIf="typeSearch == 7">{{ 'Phone' | translate }}</label>
                              <input #search_coverage name="search_coverage" required class="form-control mmww after" />
                            </div>
                          </div> -->
                          <div class="cases-from after">
                            <div class="card-header-center footer after">
                              <button [disabled]="
                                  searchForm.form.invalid || searchForm.form.pending
                                " type="submit" class="btn secundary-btn">
                                <ng-container *ngIf="typeSearch == TYPE_SEARCH.BY_CONECTION || typeSearch == TYPE_SEARCH.MANUAL_CASE; else search">
                                  {{ "Continue" | translate }}
                                </ng-container>
                                <ng-template #search>
                                  {{ "Search" | translate }}
                                </ng-template>
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>


  <!-- Result after Search -->
 
  <div>
    <div class="container-fluid">
      <div class="row mb-3 justify-content-center" *ngFor="let sale of assistancesales; let i = index">
        <div class="card">
          <div class="card-header-search color">
            <div class="header-div-left">
              <ng-container>
                <i class="far fa-user" aria-hidden="true"></i>
                {{ sale.member.name | titlecase }}
              </ng-container>
            </div>
            <div class="header-div-center">
              {{ sale.plan.product.sponsor.name | titlecase }}
            </div>
            <div class="header-div-right">
              {{ sale.member.membercountry.name | titlecase }}
            </div>
          </div>
          <div class="card-body-search card-column-flex">
            <br>
            <table  class="table table-striped table-condensed" aria-label="saletable">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ "Sale" | translate }}</th>
                  <th scope="col">{{ "Plan" | translate }}</th>
                  <th scope="col">{{ "Product" | translate }}</th>
                  <th scope="col">{{ 'Date Effective' | translate }}</th>
                  <th scope="col">{{ 'Cancellation Date' | translate }}</th>
                  <th scope="col">{{ 'Cancellation Reason' | translate }}</th>
                  <th scope="col">{{ 'Status' | translate }}</th>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>{{ sale.code | titlecase }}
                    <span *ngIf="sale?.is_dependent">
                      - {{ "Dependent" | translate }}
                    </span>
                    <span *ngIf="!sale?.is_dependent">
                      - {{ "Holder" | translate }}
                    </span>
                  </td>
                  <td>{{ sale.plan.name | titlecase }}</td>
                  <td>{{ sale.plan.product.name | titlecase }}</td>
                  <td>{{ sale.date_effective | titlecase }}</td>
                  <td>{{ sale.date_canceled | titlecase }}</td>
                  <td>{{ sale.cancellation_reason | titlecase }}</td>
                  <td>{{ (getStatusText(sale.status) | titlecase) | translate }}</td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table  class="table table-striped table-condensed" aria-label="identitytable">
              <thead>
                <tr>
                  <th scope="col"></th>
                  <th scope="col">{{ "Identity" | translate }}</th>
                  
                  <th scope="col">{{ "Name" | translate }}</th>
                  
                  <th scope="col" *ngIf="sale?.car;">{{ "Car Plate" | translate }}</th>
                  <th scope="col"></th>
                  <th scope="col" style="text-align: center; width: 100px;"></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td></td>
                  <td>{{ sale.member.national_id }}</td>
                  
                  <td>{{ sale.member.name }}</td>

                  <td *ngIf="sale?.car;">{{ sale.car?.car_plate}}</td>

                  <ng-container *ngIf="sale.member_sale_classification == null; else notNullTemplate">
                    <td align="center" *ngIf="sale.member.member_classification" style="align-content: center;">
                      <img alt="" class ="imagen" [src]="getUrlImageMemberClassification(sale.member.member_classification)" >
                    </td>
                    <td *ngIf="!sale.member.member_classification">
                    </td> 
                    <td style="text-align: center;">
                    </td>
                  </ng-container>
                  
                  <ng-template #notNullTemplate>
                    <td align="center" *ngIf="sale.member_sale_classification" style="align-content: center;">
                      <img alt="" class ="imagen" [src]="getUrlImageMemberClassification(sale.member_sale_classification)" >
                    </td>
                    <td *ngIf="!sale.member_sale_classification">
                    </td> 
                    <td style="text-align: center;">
                    </td>
                  </ng-template>
        
                 
                </tr>
              </tbody>
            </table>
          </div>
          <div class="card-footer-search">
            <button type="button" class="btn btn-light btn primary-btn" (click)="editCase(sale.member.id,sale.plan.product.id,sale.assistance_plan_id,sale.id,sale.member.name)" >
              {{ "Edit" | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="inline-paginator w-100 text-center mb-2">
        <p-paginator
          [rows]="conf.searchPage" [totalRecords]="totalCount"
          (onPageChange)="nextPage($event)">
        </p-paginator>
      </div>
    </div>
  </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--END VISTA DE EDITAR CASO MANUAL-->


<div *ngIf="showletter">
  <div class="container-fluid">
    <div class="container-morfeo">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-container">
              <div class="title-panel">
                <img alt="" class="go-to-back-title" (click)="hideletter();" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">

                
                <h1>
                  {{ 'Letter of Authorization' | translate }}
                </h1>
              </div>

              <div class="p-4">

  <app-assistance-letterauthorization [case_id]="case_id" [titular_name]="assistancecase.member.name" [opcion]="1"
    [applicant_name]="applicant_name" [applicant_id]="applicant_id" [country_id]="assistancecase.country_id"
    [services_group]="servicegroups" [assistancecase]="assistancecase" [provider]="provider_letter" (getLetter)="getLetter()" [patient_data]="patient_data">


  </app-assistance-letterauthorization>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



<div *ngIf="showletter2">
  <div class="container-fluid">
    <div class="container-morfeo">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-container">
              <div class="title-panel">
                <img alt="" class="go-to-back-title" (click)="hideletter();" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">

                
                <h1>
                  {{ 'Letter of Discount' | translate }}
                </h1>
              </div>

              <div class="p-4">

  <app-assistance-letterauthorization [case_id]="case_id" [titular_name]="assistancecase.member.name" [opcion]="2"
    [applicant_name]="applicant_name" [cost_]= "pago_copago" [applicant_id]="applicant_id" [country_id]="assistancecase.country_id"
    [services_group]="servicegroups" [provider]="provider_letter" [dental_letter]="dentalLetter" (getLetter)="getLetter()" [patient_data]="patient_data">


  </app-assistance-letterauthorization>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showletter3">
  <div class="container-fluid">
    <div class="container-morfeo">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-container">
              <div class="title-panel">
                <img alt="" class="go-to-back-title" (click)="hideletter();" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">

                
                <h1>
                  {{ 'Letter of Participation' | translate }}
                </h1>
              </div>

              <div class="p-4">

  <app-assistance-letterauthorization [case_id]="case_id" [titular_name]="assistancecase.member.name" [opcion]="3"
    [applicant_name]="applicant_name" [cost_]= "pago_copago" [applicant_id]="applicant_id" [country_id]="assistancecase.country_id"
    [services_group]="servicegroups" [provider]="provider_letter" [dental_letter]="dentalLetter" (getLetter)="getLetter()" [patient_data]="patient_data">


  </app-assistance-letterauthorization>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf="showletter4">
  <div class="container-fluid">
    <div class="container-morfeo">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-container">
              <div class="title-panel">
                <img alt="" class="go-to-back-title" (click)="hideletter();" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">

                
                <h1>
                  {{ 'Letter of Authorization Vet' | translate }}
                </h1>
              </div>

              <div class="p-4">

  <app-assistance-letterauthorization [case_id]="case_id" [titular_name]="assistancecase.member.name" [opcion]="4"
    [applicant_name]="applicant_name" [applicant_id]="applicant_id" [country_id]="assistancecase.country_id"
    [services_group]="servicegroups" [provider]="provider_letter" (getLetter)="getLetter()" [patient_data]="patient_data">


  </app-assistance-letterauthorization>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="showletter5">
  <div class="container-fluid">
    <div class="container-authorization-letter">
      <div class="row">
        <div class="col-sm-12">
          <div class="card">
            <div class="card-container">
              <div class="title-panel">
                <img alt="" class="go-to-back-title" (click)="hideletter();" [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/go_to_back_white.svg' | company">
                <h1>
                  {{ 'Dental authorization letter' | translate }}
                </h1>
              </div>

              <div class="p-4">
                <app-assistance-letterauthorization 
                  [case_id]="case_id" [opcion]="5">

                </app-assistance-letterauthorization>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--letter discount dialog -->
<p-dialog header="{{ 'Letter of Discount' | translate }}" [(visible)]="showletterdiscount" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500" [blockScroll]="true">
  <app-assistance-letterauthorization *ngIf="assistancecase" [case_id]="case_id" [titular_name]="assistancecase?.member?.name" [agente]="agente"
    [opcion]="2" [applicant_name]="applicant_name" [applicant_id]="applicant_id" [country]="country" [provider_name_]="provider_name_" [provider_address_]="provider_address_">

  </app-assistance-letterauthorization>
</p-dialog>

<!--assign / unassign user dialog -->
<p-dialog header="{{ 'Unassign me this case' | translate }}" [(visible)]="showCommentUserDialog" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500" [blockScroll]="true">
  <app-assistance-tickets-comment [Ticket]="commentTicket" [editFlag]="editcommentflag" [disabled]="isDisabled"
    (update)="onTicketUpdate($event)" (create)="onTicketCreate($event)" (cancelEvent)="onCancelEdit()" #newForm>
  </app-assistance-tickets-comment>
</p-dialog>

<!--cancel dialog -->
<p-dialog header="{{ 'Cancel' | translate }} {{groupservicename}}" [(visible)]="cancelDialog" [modal]="true"
  [draggable]="false" [style]="{width: '50vw'}" [blockScroll]="true">
  <app-cancel-tickets-form [Ticket]="cancelTicket" [disabled]="isDisabled" (create)="onCancelCreate($event)"
    (cancelEvent)="onCancelEdit()" [buca_plan_service]="buca_plan_service" [sds_provider]="sds_provider" [sinister_plan_service]="sinister_plan_service" [assistance_plan_service]="additionalplanservice" [totalCount]="totalCount" #newForm>
  </app-cancel-tickets-form>
</p-dialog>

<!--provider arrived time alert dialog -->
<p-dialog header="{{ 'Notification' | translate }}" (onHide)="canCloseTicket(closedticket)" [(visible)]="alertDialog"
  [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500" [blockScroll]="true">
  <div>
    <span>
      {{ 'The service' | translate }}
      "{{ groupservicename }}"
      {{ 'took longer than 30 minutes to resolve' | translate }}
    </span>
  </div>
  <div class="footer-btns">
    <button type="button" class="btn primary-btn wa" (click)="this.alertDialog = false">
      {{ 'Close' | translate }}
    </button>
  </div>
</p-dialog>

<!-- supervisor confirm dialog -->
<p-dialog header="{{ 'Supervisor Confirm' | translate }}" [(visible)]="showSupervisorDialog" [responsive]="true"
  [modal]="true" [draggable]="false" [breakpoint]="500" [blockScroll]="true" (onHide)="onCancelSupervisor()">
  <form class="form-horizontal" #form="ngForm" (ngSubmit)="confirmSupervisor()">
    <div class="mb-3 row">
      <div class="form-group col-sm-12">
        <i aria-hidden="true" *ngIf="billprice" class="fa fa-info-circle pointer"></i>
        <span>
          {{ 'Provider price is higher more than max amount' | translate }}.
          {{ 'Please confirm with the supervisor the information' | translate }}.
        </span>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="form-group col-sm-12">
        <label class="control-label">{{ 'Email' | translate }}:</label>
        <div>
          <input autocomplete="new-email" type="email" name="email" class="form-control" required
            [(ngModel)]="supervisor.email" pattern="[^@]+@[^@]+" placeholder="{{ 'Enter email' | translate }}"
            #email="ngModel">
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="form-group col-sm-12">
        <label class="control-label">{{ 'Password' | translate }}:</label>
        <div>
          <input autocomplete="new-password" type="password" name="password" class="form-control" required
            [(ngModel)]="supervisor.password" placeholder="{{ 'Enter password' | translate }}" #password="ngModel">
        </div>
      </div>
    </div>
    <div class="mb-3 row">
      <div *ngIf="showwarinningmessage" class="form-group col-sm-12">
        <span style="color: red">
          {{ 'Invalid Email or Password' | translate }}
        </span>
      </div>
    </div>
    <div class="mb-3 row">
      <div class="col-md-12 text-end mt-2">
        <button type="button" class="btn secundary-btn btn secundary-btn-fw" (click)="onCancelSupervisor()">
          {{ 'Cancel' | translate }}
        </button>
        <button type="submit" class="btn primary-btn btn primary-btn-fw"
          [disabled]="form.form.invalid || form.form.pending || isdisabled_confirm">
          {{ 'Confirm' | translate }}
        </button>
      </div>
    </div>
  </form>
</p-dialog>

<!-- BillPrice info -->

<!-- service configuration dialog -->
<p-dialog header="{{ 'Service Configuration' | translate }}" [(visible)]="serviceConfiguration" [responsive]="true"
  [modal]="true" [draggable]="false" [blockScroll]="true" [breakpoint]="500">
  <app-service-config [Ticket]="serviceConfigTicket" (cancelEvent)="onCancelEdit()" (setService)="onSetService($event)">
  </app-service-config>
</p-dialog>



<p-dialog [(visible)]="showPreviewDialog" [responsive]="true" [class.ui-dialog-titlebar]="true" [modal]="true"
  [draggable]="false" [blockScroll]="true" [breakpoint]="500" [style]="{'width': '80vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Download Attachment' | translate }}
  
  </ng-template>

  

  <app-attachment-preview [setAttachment]="setAttachment" (cancelEvent)="closePreviewAttachment()"
    (download)="closePreviewAttachment()" #downloadForm>
  </app-attachment-preview>
</p-dialog>




<!-- Date change -->
<p-dialog [(visible)]="modifyDate" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true">
  <ng-template pTemplate="header">
    
    {{ 'Edit Date' | translate }}
  
  </ng-template>
  
  <app-provider-arr-time-update (saved)="updatedDate($event)">
  </app-provider-arr-time-update>

</p-dialog>



<!-- <p-dialog [(visible)]="showProviderDialog" [modal]="true" [draggable]="false" [blockScroll]="true" [positionTop]="100"
  (onHide)="hideProviderCard()" [style]="{width: '50vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Provider Information' | translate }}
  
  </ng-template>
  
  <app-assistance-provider-card [provider_id]="case_provider_id" [provider_site_id]="case_provider_site_id"
    [coverage_id]="case_coverage_id" [service_id]="case_service_id" [case_id]="case_id">
  </app-assistance-provider-card>

</p-dialog> -->


<p-dialog [(visible)]="showCaseFormDialog" [modal]="true" [draggable]="false" [blockScroll]="true" [positionTop]="100"
  (onHide)="hideProviderCard()" [style]="{width: '80vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Management detail' | translate }}
  
  </ng-template>
  
  <app-case-form [visible]="showCaseFormDialogTicketInfo" [latitude]="assistancecase.latitude" [longitude]="assistancecase.longitude" [assistancecase]="assistancecase" [editevent]="editevent" (update)="updateTicket($event)">
  </app-case-form>
</p-dialog>

<p-dialog [(visible)]="showCaseFormDialogTicketInfo" [modal]="true" [draggable]="false" [blockScroll]="true" [positionTop]="100"
  (onHide)="hideProviderCard()" [style]="{width: '80vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Management detail' | translate }}
  
  </ng-template>
  
  <app-case-form [visible]="showCaseFormDialogTicketInfo" [latitude]="assistancecase.latitude" [longitude]="assistancecase.longitude" [assistancecase]="assistancecase" [editevent]="editevent" (update)="updateTicket($event)" [isTiketInfo]="true">
  </app-case-form>
</p-dialog>

<p-dialog
[(visible)]="showBucaCodesDialog" [responsive]="true"
[modal]="true" [draggable]="false" [breakpoint]="500"
[blockScroll]="true" [positionTop]="100"
(onHide)="hideBucaCodesDialog()"

>
  <ng-template pTemplate="header">
    
  {{ 'BUCA Codes' | translate }}

  </ng-template>
<app-assistance-buca-codes-card
[case_buca_id]="case_buca_id" #bucaCodes>
</app-assistance-buca-codes-card>

</p-dialog>

<p-dialog header="{{ 'Courtesy' | translate }}" [(visible)]="showCourtesyDialog" [responsive]="true" [modal]="true"
  [draggable]="false" [breakpoint]="500" [blockScroll]="true" [style]="{width: '40vw'}">
  <app-assistance-courtesy [Ticket]="commentTicket" [editFlag]="editcommentflag" [disabled]="isDisabled"
    [assistancecase]="assistancecase" (update)="onTicketUpdate($event)" (create)="onTicketCreate($event)"
    (cancelEvent)="onCancelEdit2()" #newForm>
  </app-assistance-courtesy>
</p-dialog>



<p-dialog header="{{ 'Send Survey' | translate }}" [(visible)]="survey_options" [responsive]="true" [modal]="true"
  [draggable]="false" [breakpoint]="200" [blockScroll]="true" [style]="{width: '50vw'}">

  <div style="text-align: center;">

    <button class="btn secundary-btn mx-2 px-4 btn-sm" (click)="send_email_survey()">
      <i class="fa fa-envelope" aria-hidden="true"></i>
      {{ 'Email' | translate }}
    </button>

    <button class="btn secundary-btn mx-2 px-4 btn-sm" *ngIf="whatsapp" (click)="send_whatsapp_survey()">
      <i class="fa fa-whatsapp" aria-hidden="true"></i>
      {{ 'Whatsapp' | translate }}
    </button>

    <button class="btn secundary-btn mx-2 px-4 btn-sm" (click)="send_sms_survey()">
      <i class="fa fa-comment-o" aria-hidden="true"></i>
      {{ 'SMS' | translate }}
    </button>


  </div>

</p-dialog>

<!-- POLICY 2 info -->
<p-popover #billInfo2 [dismissable]="true">
  <div *ngIf="assistancecase && assistancecase?.grouping_id" class="price-info-panel">
    <div *ngIf="assistancecase?.grouping_id" class="price-attributes-panel">
      <p>
        <strong>{{ "Grouping id" | translate }}:</strong>
        {{ assistancecase?.grouping_id ? assistancecase?.grouping_id : "N/A" }}
      </p>

      <p>
        <strong>{{ "Grouping" | translate }}:</strong>
        {{ assistancecase?.grouping_chubb? assistancecase?.grouping_chubb : "N/A" }}
      </p>
    </div>

    <div *ngIf="assistancecase?.attendance_identifier" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center"
      style="border-bottom: 1px solid #e7e7e7; margin-bottom: 11px;">
      <h3
        style="font-style: normal; font-weight: 700; font-size: 1rem; line-height: 21px; margin-top: 21px;">
        {{"Special conditions" | translate}} </h3>



    </div>

    <div *ngIf="assistancecase?.attendance_identifier">

      <p>
        <strong>{{ "Id assistance" | translate }}:</strong>
        {{ assistancecase?.attendance_identifier?
        assistancecase?.attendance_identifier : "N/A" }}
      </p>

      <p>
        <strong>{{"Text assistance" | translate }}:</strong>
        {{ assistancecase?.free_text_attendance?
        assistancecase?.free_text_attendance : "N/A" }}
      </p>

      <p>
        <strong>{{ "Apply survey"| translate }}:</strong>
        {{ assistancecase?.apply_survey?
        "Si" : "No" }}
      </p>

      <p>
        <strong>{{ "Apply alerts"| translate }}:</strong>
        {{ assistancecase?.apply_alerts?
        "Si" : "No" }}
      </p>

      <p>
        <strong>{{ "Mail alerts"| translate }}:</strong>
        {{ assistancecase?.alert_mail?
        assistancecase?.alert_mail : "N/A" }}
      </p>
    </div>
  </div>

  <div *ngIf="!assistancecase" class="price-info-panel">
    <h3
      style="font-style: normal; font-weight: 700; font-size: 1rem; line-height: 21px; margin-top: 21px;">
      {{"No additional information" | translate}} </h3>
  </div>

</p-popover>





<!-- LLAMO al nuevo componente de reasignar proveedor -->
<div *ngIf="showReasignProviderView" class="col-sm-12">
  <div *ngFor="let servicegroup of servicegroups">
<app-assistance-reassign-view-provider
[service]="case_service_id"
(ocultar) = "hideReasignProvidercard($event)"
[case_id_input]="case_id"
[totalCount]="totalCount" [servicegroup]="servicegroup"
      [grouptickets]="servicegrouptickets[servicegroup.service_id]" [categories]="assistancecategories"
      [countries]="countries" [flagAssignProvider]="flagAssignProvider" [showstep]="showstep[servicegroup.service_id]"
      [assistancecase]="assistancecase" [caseLocation]="caseLocation" [disabled]="isDisabled"
      [disableallstep]="disableallstep" [sale_canceled]="sale_canceled" [titular_name]="assistancecase?.member?.name"
      [tel]="phone" [readonly]="stepperReadOnly" [tipo_servicio]="serviceCategories[0]"
      [usuario_asesor]="assistancecase?.created_by?.username" [buca_plan_service] = "buca_plan_service" [sinister_plan_service] = "sinister_plan_service" [assistance_plan_service] = "additionalplanservice" [sds_provider]="sds_provider"  (notifyAssignProviderView)="notifyAssignProviderView()"
      (update)="onTicketCreate($event)" (setUserProvider)="gotUserProvider($event)" (buca_message)="buca_message($event)" (activeIndexReady)="onStepsActiveIndexReady(
          $event, servicegroup.service_id
        )"
      [inlatitude]="assistancecase.latitude" [inlongitude]="assistancecase.longitude"  
        
        >
</app-assistance-reassign-view-provider>
</div>
</div>

<p-dialog [(visible)]="showRisks" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [style]="{width: '40vw', height:'18vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Risky events' | translate }}
  
  </ng-template>
  
  <form #formRisk="ngForm" (ngSubmit)="onSetRisk()" *ngIf="assistancecase">
    <div class="container">
      <div class="row mb-4">
        <div class="col">
          <label class="control-label">{{ 'Risk' | translate }}</label>
          <select name="risk" class="form-control" [(ngModel)]="assistancecase.service_rating">
            <option [ngValue]="null">---</option>
            <option *ngFor="let risk of risks" [value]="risk.value_">
                {{ risk.description }}
              </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button type="button" class="btn secundary-btn btn secundary-btn-fw" (click)="showRisks = false"> {{ 'Cancel'
            | translate }} </button>
          <button type="submit" class="btn primary-btn btn primary-btn-fw btn-margin"
            [disabled]="formRisk.form.invalid || formRisk.form.pending"> {{ 'Save' | translate
            }} </button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>


<p-dialog 
  header="{{ 'Triage' | translate }}" [(visible)]="triage_window"
  [responsive]="true" [modal]="true" [draggable]="false"
  [breakpoint]="100" [blockScroll]="true">

  <div style="text-align: center;">
  
   
  <p class="sectionTitle"><strong>{{'Choose a color from the Triage'|translate}}<span class="req">*</span></strong></p>
       <div class="col-sm-3" style="display: flex;
       align-items: center;
       justify-content: center;
       width: 100%;">
          <!-- <div id="traffic-light"  >
             <div class="{{getclass1(1)}}" (click)="setRed()"></div>
             <div class="{{getclass2(2)}}" (click)="setYellow()"></div>
             <div class="{{getclass3(3)}}" (click)="setGreen()"></div>
           </div>-->

            <button class="{{getclass1(1)}}" (click)="setRed()">Emergencia</button>
            <button class="{{getclass2(2)}}" (click)="setYellow()">Urgente</button>
            <button class="{{getclass3(3)}}" (click)="setGreen()">No Urgente</button>
       </div>
       <br>

       <div class="form-group col-md-12">
        <div class="col-md-12 text-end mt-2">
          <button class="btn primary-btn btn primary-btn-fw"
          (click)="update_triage()">
        
          {{ 'Save' | translate }}
          </button>
          <button
            type="button" class="btn secundary-btn btn secundary-btn-fw"
            (click)="onCancelT()">
            {{ 'Cancel' | translate }}
          </button>
        </div>
      </div>


  

       
  </div>
</p-dialog>

<p-dialog [(visible)]="showReimbursementAmount" [responsive]="true" [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true" [style]="{width: '45vw', height: '650px'}">
  <ng-template pTemplate="header">
    
    {{ 'Reimbursement Amount' | translate }}
  
  </ng-template>
  
  <div class="mb-3">
    <strong>
      {{ 'Please complete date and amount of reimbursement' | translate }}
    </strong>
  </div>
  <div class="tr-header-center">
    <form #reimburseAmountForm="ngForm" (ngSubmit)="onSaveCaseReimbursementAmount()">
      <div>




        <div class="row mb-3">
          <div class="col text-start">
            <label class="control-label" for="reimbursementDate">{{ 'Date of request' | translate }}</label>
            <div>
              <!-- [disabled] = 'hasCaseReimbursementAmount' -->
              <p-datepicker inputStyleClass="form-control"
                inputId="reimbursementDate" name="reimbursement_date" 
                [(ngModel)]="assistancecase.reimbursement_request_date" dateFormat="dd/mm/yy" [required]="true">
              </p-datepicker>
            </div>
          </div>
        </div>

        

        <div class="row mb-3">
          <div class="col text-start">
            <label class="control-label" for="reimbursementDate">{{ 'Reimbursement payment date' | translate }}</label>
            <div>
              <div class="col-sm-12">
              <!-- [disabled] = 'hasCaseReimbursementAmount' -->
              <p-datepicker inputStyleClass="form-control"
                inputId="reimbursementDate" name="reimbursement_date" 
                [(ngModel)]="assistancecase.reimbursement_date" dateFormat="dd/mm/yy" [required]="true">
              </p-datepicker>
            </div>
            </div>
          </div>
        </div>


        <div class="row mb-3">
          <div class="col text-start mb-3">
            <label class="control-label col-sm-3">{{ 'Area' | translate }}:</label>
            <!-- <div class="col-sm-12">
              <select  required class="form-control" name="type" [(ngModel)]="assistancecase.reimbursement_area">
                <option [ngValue]="null">---</option>
                <option [ngValue]="10">CABINA</option>
                <option [ngValue]="20">SAC</option>
              </select>
            </div> -->


            <div class="input-group mb-3" style="width: auto;">
               <p-multiSelect 
            [options]="areasReembolso" 
            [(ngModel)]="selectedAreasReembolso" 
            optionLabel="name" 
            display="chip"
            placeholder="Selecciona areas"
            [ngModelOptions]="{standalone: true}"
            [required]="true"
            ></p-multiSelect>
          </div> 


          </div>
        </div>
        <div class="row mb-3">
          <div class="col text-start mb-3">
            <label class="control-label col-sm-3">{{ 'Reason Reimbursement' | translate }}:</label>
            <!-- <div class="col-sm-12">
              <select  required class="form-control" name="type" [(ngModel)]="assistancecase.reimbursement_area">
                <option [ngValue]="null">---</option>
                <option [ngValue]="10">CABINA</option>
                <option [ngValue]="20">SAC</option>
              </select>
            </div> -->


            <div class="input-group mb-3" style="width: auto;">
               <p-multiSelect 
            [options]="reasonsReembolso" 
            [(ngModel)]="selectedReasonsReembolso" 
            optionLabel="name" 
            display="chip"
            placeholder="Selecciona motivo de reembolso"
            [ngModelOptions]="{standalone: true}"
            [required]="true"
            ></p-multiSelect>
          </div> 


          </div>
        </div>

        <div class="row mb-3">
          <div class="col text-start">
            <label class="control-label" for="reimbursementAmount">
              {{ 'Amount2' | translate }}
            </label>
            <div class="input-group mb-3">
              <span class="input-group-text" id="basic-addon1">{{ assistancecase?.country?.currency_symbol }}</span>
              <input type="text" name="reimbursementAmount" class="form-control"
                placeholder="{{ 'Enter charged amount' | translate }}" required
                mask="separator" thousandSeparator="," name="reimbursement_amount"
                [(ngModel)]="assistancecase.reimbursement_amount">
              
                <!-- [disabled] = 'hasCaseReimbursementAmount' -->
            </div>
            <!-- <input    > -->
          </div>
        </div>

        <!-- <div class="col text-start mb-3">
          <label class="control-label col-sm-3">{{ 'Supervisor' | translate }}:</label>
          <div class="col-sm-12">
            <select required class="form-control" name="type" [(ngModel)]="assistancecase.reimbursement_supervisor_id">
              <option *ngFor="let supervisor of supervisors_reimbursements" [ngValue]="supervisor.id">{{ supervisor.name }}</option>
            </select>
          </div>
        </div> -->
   
        <!-- *ngIf="!hasCaseReimbursementAmount" -->
        <ng-container>
          <div class="row mb-3">
            <div class="col text-start">
              <label class="control-label" for="reimburseAmountComment">
                {{ 'Comment' | translate }}
              </label>
              <textarea rows="9" class="form-control" [(ngModel)]="reimburseAmountComment"
                placeholder="{{ 'Write a comment' | translate }}" required name="reimburseAmountComment">
                </textarea>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="footer-btns">
                <button type="button" class="btn secundary-btn btn secundary-btn-fw"
                  (click)="showReimbursementAmount=false; showDialogGeneral=true">{{ 'Cancel'
                  | translate }} </button>
                <button [disabled]="reimburseAmountForm.form.invalid || reimburseAmountForm.form.pending"
                  class="btn primary-btn btn primary-btn-fw btn-margin" type="submit">{{ 'Save' | translate
                  }}</button>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
</p-dialog>


<p-dialog [(visible)]="showComplaints" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [blockScroll]="true" [style]="{width: '40vw', height:'18vw'}">
  <ng-template pTemplate="header">
    
    {{ 'Possibles complaints' | translate }}
  
  </ng-template>
  
  <form #formComplaint="ngForm" (ngSubmit)="saveComplaint()" *ngIf="assistancecase">
    <div class="container">
      <div class="row mb-4">
        <div class="col">
          <label class="control-label">{{ 'Complaint' | translate }}</label>
          <select name="complaint" class="form-control" [(ngModel)]="assistancecase.complaint">
            <option [ngValue]="null">---</option>
            <option *ngFor="let complaint of complaints" [value]="complaint.value_">
              {{ complaint.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <button type="button" class="btn secundary-btn btn secundary-btn-fw" (click)="showComplaints = false"> {{ 'Cancel'
            | translate }} </button>
          <button type="submit" class="btn primary-btn btn primary-btn-fw btn-margin"
            [disabled]="formComplaint.form.invalid || formComplaint.form.pending"> {{ 'Save' | translate
            }} </button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog [(visible)]="showUploadFileDialog" [responsive]="true" [class.ui-dialog-titlebar]="true" [modal]="true"
          [draggable]="false" [blockScroll]="true" [breakpoint]="500" [style]="{'width': '75vw' }">
  <ng-template pTemplate="header">
    
    {{ 'Attachment' | translate }}
  
  </ng-template>

  
  <div class="p-4">
    <div class="content-panel">
      <div class="table-responsive">
        <table class="table table-condensed table-striped" aria-label="filetypetable">
          <thead>
            <tr>
              <th scope="col">{{ 'ID' | translate }}</th>
              <th scope="col">{{ 'File Type' | translate }}</th>
              <th scope="col">{{ 'User' | translate }}</th>
              <th scope="col">{{ 'File' | translate }}</th>
              <th scope="col">{{ 'Date' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let caseAttachment of caseAttachmentsCondicionado">
              <td>{{ caseAttachment.id }}</td>
              <td>{{ fileTypesCondicionado[caseAttachment.attachment?.attachment_type] | translate }}</td>
              <td>{{ caseAttachment.attachment?.user?.username }}</td>
              <td>
                <a
                  *ngIf="caseAttachment.attachment"
                  class="link"
                  (click)="downloadAttachment(caseAttachment.attachment)"
                  style="cursor: pointer">
                  {{ caseAttachment.attachment?.name }}
                </a>
                <span *ngIf="!caseAttachment.attachment">
                  {{ 'File not generated' | translate }}
                </span>
              </td>
              <td>
                {{
                  caseAttachment.attachment?.created_time
                  | currentDate: { offset: timezoneOffset }
                  | date:'MMM'
                  | translate
                }}
                {{
                  caseAttachment.attachment?.created_time
                  | currentDate: { offset: timezoneOffset }
                  | date:'d' | translate
                }},
                {{
                  caseAttachment.attachment?.created_time
                  | currentDate: { offset: timezoneOffset }
                  | date:'hh:mm a'
                }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</p-dialog>

<p-dialog [(visible)]="showHistoryDialog" [responsive]="true" [class.ui-dialog-titlebar]="true" [modal]="true"
          [draggable]="false" [blockScroll]="true" [breakpoint]="500" [style]="{'width': '90vw' }">
  <ng-template pTemplate="header">
    
    {{ 'Historial de Casos' | translate }}
  
  </ng-template>

  
  <div class="p-4">
    <div class="content-panel">
      <app-assistance-cases-history *ngIf="assistancecase?.assistance_sale_id" [setSale]="setSale"></app-assistance-cases-history>
    </div>
  </div>
</p-dialog>

<p-dialog [(visible)]="showPreviewDialogConditionFile" [responsive]="true" [class.ui-dialog-titlebar]="true" [modal]="true"
  [draggable]="false" [blockScroll]="true" [breakpoint]="500" [style]="{'width': '80vw' }">
  <ng-template pTemplate="header">
    
    {{ 'Download Attachment' | translate }}
  
  </ng-template>

  

  <app-attachment-preview [setAttachment]="setAttachmentCondicionado" (cancelEvent)="closePreviewAttachmentCondicionado()"
    (download)="closePreviewAttachment()" #downloadForm>
  </app-attachment-preview>
</p-dialog>


<form class="cases-from" #form="ngForm" *ngIf="showFilesView">
  <div class="card mt-3 mb-3">
    <div class="card-header-search color">
      <img class="go-to-back-title go-to-back-title2"
        (click)="showFilesView = false; showProgramedService = false; showDialogGeneral = true; showBillFormDialog = false; showExceptionDialog = false;  showAudiosDialog = false; getAssistanceTicket()"
        src="../../../../assets/images/go_to_back_white.svg" alt="back">
      <p>{{ 'Files' | translate }}</p>
    </div>
    <div class="container">
      <div class="row">
        <div class="col pb-5">

          <div class="search-panel">
            <div class="pt-4 pb-4 ps-1 ">
              <div class="mb-3 row">
                <div class="form-group col-sm-12">
                  <label class="control-label">
                    {{ 'Load File' | translate }}:
                  </label>
                  <div>
                    <app-import [fileTypes]="fileTypes" [requiredType]="true" [acceptedTypes]="acceptedTypes" [disabled]="false"
                      (onSave)="onSaveImport($event)" [headerTitle]="'Import File'" [filesToImport]="filesToImport"
                      [maxFilesToImport]="1">
                    </app-import>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="content-panel">
            <div class="table-responsive">
              <table class="table table-condensed table-striped" aria-label="table">
                <thead>
                  <tr>
                    <th scope="col">{{ 'ID' | translate }}</th>
                    <th scope="col">{{ 'File Type' | translate }}</th>
                    <th scope="col">{{ 'User' | translate }}</th>
                    <th scope="col">{{ 'File' | translate }}</th>
                    <th scope="col">{{ 'Date' | translate }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let caseAttachment of caseAttachments">
                    <td>{{ caseAttachment.id }}</td>
                    <td>{{ fileTypes[caseAttachment.attachment?.attachment_type] | translate }}</td>
                    <td>{{ caseAttachment.attachment?.user?.username }}</td>
                    <td>
                      <a
                        *ngIf="caseAttachment.attachment"
                        class="link"
                        (click)="downloadAttachmentCases(caseAttachment.attachment)"
                        style="cursor: pointer">
                        {{ caseAttachment.attachment?.name }}
                      </a>
                      <span *ngIf="!caseAttachment.attachment">
                        {{ 'File not generated' | translate }}
                      </span>
                    </td>
                    <td>
                      {{
                        caseAttachment.attachment?.created_time
                        | currentDate: { offset: timezoneOffset }
                        | date:'MMM'
                        | translate
                      }}
                      {{
                        caseAttachment.attachment?.created_time
                        | currentDate: { offset: timezoneOffset }
                        | date:'d' | translate
                      }},
                      {{
                        caseAttachment.attachment?.created_time
                        | currentDate: { offset: timezoneOffset }
                        | date:'hh:mm a'
                      }}

                    
                        <!-- <i style="margin-left:15px" title="Enviar documento reembolso" *ngIf="fileTypes[caseAttachment.attachment?.attachment_type]=='Reimbursement document' && assistancecase.issinester" class="fa fa-envelope" (click)="changeReinsburmentFileFlag(caseAttachment.attachment_id)"></i>
   -->
                        <!-- <button style="margin-left: 15px; height:70%" *ngIf="fileTypes[caseAttachment.attachment?.attachment_type]=='Reimbursement document'" type="button" class="btn btn-xs btn-circle-morfeo" title="Enviar documento reembolso"  (click)="changeReinsburmentFileFlag(caseAttachment.attachment_id)"><img  src="/assets/images/others/mail.png" alt=""></button> -->

                    </td>

                        
             
               
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>

<p-dialog [style]="{'width':'1200px'}" width="1200" header="{{ 'Send Survey' | translate }}" [(visible)]="open" [responsive]="true" [modal]="true">

  <app-select-send-survey-method [phone]="customer_phone" *ngIf="open" [survey_id]="id_survey" [reference_number]="currentProcessId" [email]="customer_email" [country_id]="country_id_survey" [client_name]="customer_name" [survey_type]="20" ></app-select-send-survey-method>

</p-dialog>





<p-dialog 
  header="{{ 'Schedule Appointment' | translate }}" [(visible)]="show_schedule_appointment"
  [responsive]="true" [modal]="true" [draggable]="false"
  [breakpoint]="100" [blockScroll]="true">
  <form #formAppointment="ngForm">
    <p-datepicker [style]="{'width':'800px'}" [inline]="true" [required]="true" name="appointment_date" [showTime]="true" hourFormat="24"
    [(ngModel)]="appointment_date"></p-datepicker>
    <!-- footer -->
    <div class="card-header-search brd">
      <div class="card-buttons-footer">
        <div class="card-left-footer">
        </div>
        <div class="card-right-footer">
          <button class="btn secundary-btn btn secundary-btn-fw"
            (click)="show_schedule_appointment = false;">
            {{ 'Cancel' | translate }} </button>
          <button class="btn primary-btn primary-btn-fw" [disabled]="formAppointment.form.invalid"
            (click)="onSetScheduleAppointment()"> {{ 'Confirm' | translate }} </button>
        </div>
      </div>
    </div>
  </form>
</p-dialog>

<!-- REIMBURSE AMMOUNT NOT SETTED-->
<p-dialog
  [(visible)]="showreimbursementalert"
  [responsive]="true" [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true">
  <div style="text-align: center;">
    <img src="../../../../assets/images/assistancecase/claims_hover.svg" alt="" style="width: 55%; aspect-ratio: 1/1;">
    <p>{{ 'Refund Ammount has not been entered' | translate }}</p>
  </div>
</p-dialog>




<p-dialog [(visible)]="showRequestLocation" [modal]="true">
  <div>
    <h2>
      <strong>{{ "Confirm and select the phone number" | translate }}</strong>
    </h2>
    <hr style="margin-top: 15px; margin-bottom: 15px;" />
    <div class="btns-popup-call">
      <div>
        <h2>{{ assistancecase.contact_name }}</h2>
      </div>
      <div class="form-check">
        <div>
          <input *ngIf="
              assistancecase.phone == null && assistancecase.phone2 == null
            " class="form-check-input" type="radio" name="flexRadioDefault" id="{{ assistancecase.phone }}"
            value="{{ assistancecase.phone }}" [checked]="checkedPhone"  (change)="onRadioPhoneChange(1)" />
          <label *ngIf="
              assistancecase.phone == null && assistancecase.phone2 == null
            " class="form-check-label" for="{{ assistancecase.phone }}">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company" />
            +{{ assistancecase.country_phone_code }} ---
          </label>
        </div>
        <div>
          <input *ngIf="assistancecase.phone != null ? true : false" class="form-check-input" type="radio"
            name="flexRadioDefault" id="{{ assistancecase.phone }}" value="{{ assistancecase.phone }}" [checked]="checkedPhone"  (change)="onRadioPhoneChange(1)" />
          <label *ngIf="assistancecase.phone != null ? true : false" class="form-check-label"
            for="{{ assistancecase.phone }}">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company" />
            +{{ assistancecase.country_phone_code }} {{ assistancecase.phone }}
          </label>
        </div>

        <div>
          <input *ngIf="assistancecase.phone2 != null ? true : false" class="form-check-input" type="radio"
            name="flexRadioDefault" id="{{ assistancecase.phone2 }}" value="{{ assistancecase.phone2 }}" [checked]="checkedPhone"  (change)="onRadioPhoneChange(1)" />
          <label *ngIf="assistancecase.phone2 != null ? true : false" class="form-check-label"
            for="{{ assistancecase.phone2 }}">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-black.svg' | company" />
            +{{ assistancecase.country_phone_code }}
            {{ assistancecase.phone2 ? assistancecase.phone2 : "---" }}
          </label>
        </div>
      </div>
    </div>
    <br />
    <div class="btns-popup-call">
      
        <div style="display: flex;">
        <h2 style="margin-right: 10px;">{{ "Other" | translate }}:</h2>
        <input class="form-check-input" type="radio"
         [checked]="checkedPhone2" (change)="onRadioPhoneChange(2)"/>
        <input type="text" name="otherPhone" class="form-control" required [(ngModel)]="otherPhone"
         minlength="8" maxlength="9" autocomplete="off"  />
       <!-- <p *ngIf="otherPhone.invalid && otherPhone.touched" class="text-danger">Debe ingresar un número de 8-9 dígitos</p> -->
      </div>
    </div>

    <div class="btns-popup-call">
      <div class="row">
        <div class="col">
          <button class="btn primary-btn buttonGreenWhite" (click)="
              requestLocation(selectLocationComponent.SHIPPING_METHOD.SMS);
              showRequestLocation = false 
            ">
            <img alt=""
              [src]="'https://storage.googleapis.com/apolo11-prod.appspot.com/company/assets/images/ticketcase/call-white.svg' | company" />
            {{ "Send link" | translate }}  
          </button>
        </div>
      </div>
    </div>
    <!-- <hr style="margin-top: 15px; margin-bottom: 15px;"  />
    <div class="btns-popup-call">
      <div class="row">
        <div class="col" style="text-align: center">
          <h2>{{ "Send Link To Email" | translate }}:</h2>
          <button class="btn secundary-btn" [disabled]="!assistancecase.email" (click)="
              requestLocation(selectLocationComponent.SHIPPING_METHOD.EMAIL);
              showRequestLocation = false
            ">
            <i class="fa fa-envelope" aria-hidden="true"></i>
            {{ "Email" | translate }}
          </button>
        </div>
      </div>
    </div> -->
  </div>
</p-dialog>

<div class="chat-overlay" *ngIf="showChatDialog" (click)="closeChatPanel()"></div>


<div class="slide-chat" [class.open]="showChatDialog">
  <div class="chat-header">
    <button class="close-btn" (click)="closeChatPanel()">
      <img alt="chevron-left"
        src="https://storage.googleapis.com/apolo11-prod.appspot.com/assistance-link-icons/Chat/chevrolet-left.svg"
        title="Return">

    </button>
    <span class="chat-title">{{ 'Case' | translate }} #{{ case_id }}</span>

  </div>

  <div class="chatBox" #scrollMe>
    <div *ngFor="let message of chatMessages" [ngClass]="{
           'msg-user': message.from === 'user',
           'msg-tech': message.from === 'technician',
           'msg-cabin': message.from === 'cabin'
         }">
      <div class="message-bubble">
        <p *ngIf="message.from === 'user'" class="msg-label user">{{ assistancecase?.member?.name }}</p>
        <p *ngIf="message.from === 'technician'" class="msg-label tech">Técnico</p>

        <ng-container [ngSwitch]="message.type">
          <ng-container *ngSwitchCase="'text'">
            <p>{{ message.text }}</p>
          </ng-container>
          <ng-container *ngSwitchCase="'image'">
            <img [src]="message.url" alt="Imagen" class="img-icon" (click)="viewFile(message)" />
          </ng-container>
          <ng-container *ngSwitchCase="'file'">
            <i class="far fa-file-pdf" style="margin-right: 5px; color: #C0392B;"></i>
            <strong>Archivo:</strong><br />
            <a [href]="message.url" target="_blank" >{{ message.file_name }}</a>
          </ng-container>
          <ng-container *ngSwitchCase="'audio'">
            <audio controls>
              <source [src]="message.url" type="audio/mpeg" />
            </audio>
          </ng-container>
          <ng-container *ngSwitchCase="'location'">
            <i class="fas fa-map-marker-alt" style="margin-right: 5px; color: #E74C3C;"></i>
            <strong>Ubicación:</strong><br />
            <a [href]="message.url_google" target="_blank">Ver en Google Maps</a><br />
            <a [href]="message.url_waze" target="_blank">Ver en Waze</a>
          </ng-container>
        </ng-container>

        <small class="msg-time">{{ message.time }}</small>
      </div>
    </div>
  </div>
  <div class="chat-input-wrapper" >
    <div class="chat-input-box">
      <button class="chat-icon-btn" (click)="toggleAttachOptions()">
        <img alt="paperclip"
          src="https://storage.googleapis.com/apolo11-prod.appspot.com/assistance-link-icons/Chat/paperclip.svg"
          title="paperclip">
      </button>

      <input [(ngModel)]="chatInput" (keydown.enter)="sendMessage()" type="text" class="chat-text-input"
        placeholder="Escribe un mensaje..." />

      <button class="chat-icon-btn" (click)="sendMessage()">
        <img alt="send"
          src="https://storage.googleapis.com/apolo11-prod.appspot.com/assistance-link-icons/Chat/paper-plane.svg"
          title="sendMessage">
      </button>
    </div>
  </div>

  <div *ngIf="showAttachOptions" @slideUpDown class="attach-modal">
    <div class="option" (click)="openGallery(); closeAttachOptions()">
      <img alt="" src="https://storage.googleapis.com/apolo11-prod.appspot.com/assistance-link-icons/Chat/galeria-bn.svg" />
      <span>Galería</span>
    </div>
    <div class="option" (click)="openFilePicker(); closeAttachOptions()">
      <img alt="" src="https://storage.googleapis.com/apolo11-prod.appspot.com/assistance-link-icons/Chat/archivo-bn.svg" />
      <span>Archivo</span>
    </div>
  </div>
  <input #fileInput type="file" hidden (change)="handleFileInput($event)" />


</div>




